{
  "common": {
    "main": {
      "project": "Projet",
      "form": "Formulaire",
      "version": "Version",
      "formSettings": "Configuration du formulaire",
      "user": "Utilisateur",
      "organization": "Organisation",
      "server": "Serveur",
      "url": "URL"
    },
    "buttons": {
      "ok": "OK",
      "cancel": "Annuler",
      "save": "Enregistrer",
      "add": "Ajouter",
      "edit": "Modifier",
      "delete": "Supprimer",
      "refresh": "Actualiser",
      "create": "Créer",
      "submit": "Soumettre",
      "clear": "Effacer",
      "selectAll": "Sélectionner tout",
      "back": "Retour",
      "next": "Suivant",
      "previous": "Précédent",
      "close": "Fermer",
      "confirm": "Confirmer",
      "yes": "Oui",
      "no": "Non",
      "search": "Rechercher",
      "filter": "Filtrer",
      "export": "Exporter",
      "import": "Importer",
      "download": "Télécharger",
      "upload": "Téléverser",
      "view": "Voir",
      "preview": "Aperçu",
      "copy": "Copier",
      "assign": "Assigner",
      "unassign": "Désassigner",
      "retry": "Réessayer",
      "loading": "Chargement..."
    },
    "dialogs": {
      "cancel": "Annuler",
      "close": "Fermer",
      "confirm": "Confirmer",
      "delete": "Supprimer",
      "save": "Enregistrer les modifications",
      "confirmTitle": "Confirmer l'action",
      "unsavedChanges": {
        "title": "Modifications non enregistrées",
        "message": "Des modifications n'ont pas été enregistrées. Fermer sans enregistrer ?"
      }
    },
    "table": {
      "headers": {
        "name": "Nom",
        "description": "Description",
        "statistics": "Statistiques",
        "status": "Statut",
        "actions": "Actions",
        "createdAt": "Date de création",
        "updatedAt": "Date de mise à jour",
        "created": "Créé",
        "updated": "Mis à jour",
        "type": "Type",
        "version": "Version",
        "id": "ID",
        "email": "E-mail",
        "role": "Rôle",
        "user": "Utilisateur",
        "project": "Projet",
        "organization": "Organisation",
        "lastSubmission": "Dernière soumission",
        "server": "Serveur",
        "url": "URL",
        "format": "Format",
        "count": "Nombre",
        "size": "Taille",
        "date": "Date",
        "time": "Heure",
        "severity": "Sévérité",
        "field": "Champ Principal",
        "form": "Formulaire",
        "state": "État",
        "roles": "Rôles",
        "groups": "Groupes",
        "formId": "ID du formulaire",
        "permissions": "Permissions",
        "enabled": "Activé",
        "disabled": "Désactivé",
        "submissions": "Soumissions",
        "publishedAt": "Publié le"
      },
      "pagination": {
        "page": "Page",
        "of": "de",
        "perPage": "par page",
        "showing": "Affichage",
        "to": "à",
        "totalEntries": "entrées totales",
        "resultsText": "résultats.",
        "perPageText": "Résultats par page"
      },
      "ariaLabels": {
        "viewDetails": "Voir les détails",
        "edit": "Modifier",
        "delete": "Supprimer",
        "previousPage": "Page précédente",
        "nextPage": "Page suivante"
      }
    },
    "status": {
      "active": "Actif",
      "inactive": "Inactif",
      "archived": "Archivé",
      "draft": "Brouillon",
      "published": "Publié",
      "pending": "En attente",
      "completed": "Terminé",
      "failed": "Échoué",
      "success": "Succès",
      "error": "Erreur",
      "warning": "Avertissement",
      "info": "Info",
      "loading": "Chargement",
      "notSet": "Non défini",
      "notSpecified": "Non spécifié",
      "notAvailable": "N/D",
      "unknown": "Inconnu",
      "enabled": "Activé",
      "disabled": "Désactivé"
    },
    "messages": {
      "confirmDelete": "Êtes-vous sûr de vouloir supprimer",
      "confirmDeleteWithName": "Êtes-vous sûr de vouloir supprimer \"{name}\" ?",
      "deleteSuccess": "Supprimé avec succès",
      "deleteError": "Erreur lors de la suppression",
      "saveSuccess": "Enregistré avec succès",
      "saveError": "Erreur lors de l'enregistrement",
      "createSuccess": "Créé avec succès",
      "createError": "Erreur lors de la création",
      "updateSuccess": "Mis à jour avec succès",
      "updateError": "Erreur lors de la mise à jour",
      "error": "Erreur",
      "loadError": "Erreur lors du chargement",
      "noData": "Aucune donnée",
      "noResults": "Aucun résultat",
      "required": "Ce champ est obligatoire",
      "invalidEmail": "Veuillez saisir un email valide",
      "confirmDeleteWithType": "Êtes-vous sûr de vouloir supprimer \"{name}\" ({type})?",
      "bulkOperationSuccess": "Opération en masse terminée avec succès",
      "bulkOperationError": "Erreur lors de l'exécution de l'opération en masse",
      "operationFailed": "Impossible d'effectuer l'opération",
      "unsavedChanges": "Le formulaire contient des modifications non enregistrées. Êtes-vous sûr de vouloir le fermer ?",
      "created": "créé",
      "updated": "mis à jour",
      "invalidUrl": "Please enter a valid URL"
    },
    "statistics": {
      "title": "Statistiques",
      "subtitle": "Revisez les métriques à l'échelle de l'organisation, les états des formulaires et l'activité des projets.",
      "overall": "Statistiques Générales",
      "byState": "Formulaires par État",
      "projectDetails": "Détails du Projet",
      "projectLedger": "Registre des projets",
      "pipeline": "État",
      "projectCount": "{count} projets",
      "noActiveForms": "Aucun formulaire actif",
      "projects": "Projets",
      "totalForms": "Total des Formulaires",
      "activeForms": "Formulaires Actifs",
      "submissions": "Soumissions",
      "forms": "Formulaires",
      "lastUpdated": "Dernière mise à jour",
      "noDataToDisplay": "Aucune donnée à afficher"
    },
    "viewMode": {
      "cards": "Cartes",
      "table": "Tableau",
      "list": "Liste",
      "grid": "Grille"
    },
    "time": {
      "today": "aujourd'hui",
      "yesterday": "hier",
      "thisWeek": "cette semaine",
      "lastWeek": "la semaine dernière",
      "thisMonth": "ce mois",
      "lastMonth": "le mois dernier",
      "allTime": "tout le temps",
      "last7Days": "7 derniers jours",
      "last30Days": "30 derniers jours",
      "last90Days": "90 derniers jours",
      "customRange": "Plage personnalisée",
      "startDate": "Date de début",
      "endDate": "Date de fin",
      "justNow": "Juste maintenant",
      "minutesAgo": "il y a {count} min",
      "hoursAgo": "il y a {count} h",
      "daysAgo": "il y a {count} jours",
      "never": "Jamais"
    },
    "placeholders": {
      "enterName": "Saisir le nom",
      "enterDescription": "Saisir la description",
      "enterEmail": "Saisir l'email",
      "enterUrl": "Saisir l'URL",
      "search": "Rechercher...",
      "selectOption": "Sélectionner une option"
    },
    "formState": {
      "title": "Changer l'État du Formulaire",
      "form": "Formulaire",
      "currentStatus": "État actuel",
      "newStatus": "Nouvel état",
      "pleaseSelectStatus": "Veuillez sélectionner un état",
      "statusChangedSuccessfully": "État du formulaire {formName} changé avec succès en {status}",
      "errorChangingStatus": "Erreur lors du changement d'état du formulaire"
    }
  },
  "admin": {
    "agent": {
      "title": "Agent Hermes",
      "subtitle": "Surveiller et gérer l'intégration de l'agent Hermes",
      "back": "Retour au tableau de bord",
      "health": {
        "title": "État de santé de l'intégration",
        "checkNow": "Vérifier maintenant",
        "latency": "Latence",
        "lastCheck": "Dernière vérification"
      },
      "stats": {
        "activeSubs": "Abonnements actifs",
        "requestsToday": "Requêtes aujourd'hui",
        "tokensToday": "Tokens aujourd'hui",
        "nearQuota": "Orgs près du quota",
        "activeSubsHint": "{total} au total",
        "nearQuotaHint": ">80% utilisé"
      },
      "config": {
        "title": "Configuration (lecture seulement)"
      },
      "jobs": {
        "title": "Jobs RQ (rapports analytiques)",
        "empty": "Aucun job récent"
      },
      "digests": {
        "title": "Digests proactifs",
        "trigger": "Déclencher manuellement",
        "historyTitle": "Historique des digests",
        "historyEmpty": "Aucun digest exécuté encore."
      },
      "selfHeal": {
        "title": "Jobs de self-healing",
        "trigger": "Exécuter maintenant"
      },
      "incident": {
        "banner": "L'intégration Hermes ou MCP est en mauvais état. Les fonctionnalités de l'agent peuvent être dégradées.",
        "title": "Attention requise"
      },
      "subscriptions": {
        "title": "Abonnements de l'agent",
        "subtitle": "Gérer les niveaux, quotas et fonctionnalités par organisation",
        "searchPlaceholder": "Rechercher une organisation...",
        "allTiers": "Tous les niveaux",
        "editTitle": "Modifier l'abonnement",
        "resetTitle": "Réinitialiser l'utilisation",
        "resetMessage": "Réinitialiser les compteurs d'utilisation pour {name} ?",
        "resetConfirm": "Réinitialiser",
        "empty": "Aucun abonnement trouvé",
        "tierDefaultsTitle": "Niveaux par défaut",
        "tierDefaultsHint": "Référence des limites depuis le SSOT backend. Changer le niveau dans le formulaire d'édition applique ces valeurs (remplacements encore possibles).",
        "columns": {
          "org": "Organisation",
          "tier": "Niveau",
          "fiveHour": "5h",
          "week": "Semaine",
          "month": "Mois",
          "features": "Fonctionnalités"
        },
        "tierDefaults": {
          "fiveHour": "5h (req / tok)",
          "week": "Semaine (req / tok)",
          "month": "Mois (req / tok)"
        }
      },
      "usage": {
        "title": "Utilisation de l'agent",
        "subtitle": "Journal d'invocations entre organisations",
        "orgIdPlaceholder": "ID de l'org",
        "allFeatures": "Toutes les fonctionnalités",
        "empty": "Aucun événement d'utilisation",
        "columns": {
          "time": "Temps",
          "org": "Organisation",
          "user": "Utilisateur",
          "feature": "Fonctionnalité",
          "tokens": "Tokens"
        }
      },
      "audit": {
        "title": "Audit des tool-calls",
        "subtitle": "Journal d'invocations MCP (actions d'écriture en particulier)",
        "orgIdPlaceholder": "ID de l'org",
        "toolPlaceholder": "Nom de l'outil",
        "writeOnly": "Outils d'écriture uniquement",
        "detailTitle": "Détail de l'audit",
        "detail": "Détail",
        "empty": "Aucun journal d'audit",
        "write": "Écriture",
        "read": "Lecture",
        "columns": {
          "time": "Temps",
          "org": "Organisation",
          "tool": "Outil",
          "write": "Écriture"
        }
      },
      "sections": {
        "metrics": "Pouls"
      }
    },
    "dialogs": {
      "deleteProject": {
        "title": "Supprimer le projet",
        "message": "Cette action est irréversible. Tous les formulaires liés seront supprimés.",
        "formsCount": "Formulaires à supprimer : {count}",
        "confirm": "Supprimer définitivement"
      },
      "deleteOrganization": {
        "title": "Supprimer l'organisation",
        "message": "Cette action est irréversible. Tous les projets et utilisateurs seront affectés.",
        "confirm": "Supprimer définitivement"
      },
      "deleteForm": {
        "title": "Supprimer le formulaire",
        "message": "Cette action est irréversible.",
        "confirm": "Supprimer définitivement"
      },
      "deleteUser": {
        "title": "Supprimer l'utilisateur",
        "message": "Cette action est irréversible. L'utilisateur perdra l'accès à toutes les organisations.",
        "confirm": "Supprimer définitivement"
      },
      "projectDetails": "Projet : {name}",
      "organizationDetails": "Organisation : {name}",
      "formDetails": "Formulaire : {name}",
      "userDetails": "Utilisateur : {name}",
      "close": "Fermer",
      "createUser": {
        "title": "Créer un utilisateur"
      },
      "editUser": {
        "title": "Modifier un utilisateur"
      },
      "fullName": "Nom complet",
      "superuser": "Superutilisateur",
      "active": "Actif"
    },
    "back": "Retour au tableau de bord",
    "chrome": {
      "sessionLabel": "Superutilisateur · toutes les actions enregistrées",
      "exit": "Quitter le mode",
      "menuTitle": "Administration",
      "sessionWarning": "La session administrateur expire dans {time}.",
      "extendSession": "Prolonger la session"
    },
    "nav": {
      "groups": {
        "overview": "Aperçu",
        "directory": "Répertoire",
        "access": "Accès",
        "integrations": "Intégrations",
        "platform": "Plateforme"
      },
      "dashboard": "Tableau de bord",
      "analytics": "Analytique",
      "users": "Utilisateurs",
      "organizations": "Organisations",
      "projects": "Projets",
      "forms": "Formulaires",
      "roles": "Rôles et permissions",
      "permissionGroups": "Groupes de permissions",
      "agent": "Agent Hermes",
      "agentDashboard": "Tableau de bord de l'agent",
      "agentSubscriptions": "Abonnements de l'agent",
      "agentUsage": "Utilisation de l'agent",
      "agentAudit": "Audit de l'agent",
      "globalOdk": "Serveurs ODK globaux",
      "system": "Système",
      "audit": "Audit",
      "subscriptions": "Facturation"
    },
    "pagination": {
      "shown": "Affichage de {start} - {end} sur {total}",
      "pageOf": "Page {page} sur {pages}",
      "previous": "Précédent",
      "next": "Suivant"
    },
    "common": {
      "tryAgain": "Réessayer",
      "showDeleted": "Afficher les supprimés",
      "hideDeleted": "Masquer les supprimés",
      "showArchived": "Afficher les archivés",
      "hideArchived": "Masquer les archivés",
      "allOrganizations": "Toutes les organisations",
      "allProjects": "Tous les projets",
      "allRoles": "Tous les rôles",
      "allStatuses": "Tous les statuts",
      "totalRecords": "Total des enregistrements : {count}",
      "orgIdPrefix": "Org #{id}",
      "projectIdPrefix": "Projet #{id}",
      "notSet": "Non défini",
      "health": {
        "healthy": "Sain",
        "degraded": "Dégradé",
        "disabled": "Désactivé",
        "unhealthy": "Malsain",
        "unknown": "Inconnu"
      }
    },
    "pages": {
      "users": {
        "title": "Gestion des utilisateurs",
        "subtitle": "Voir et gérer tous les utilisateurs du système",
        "addUser": "Ajouter un utilisateur",
        "searchPlaceholder": "Rechercher des utilisateurs...",
        "superuserBadge": "Superutilisateur",
        "userBadge": "Utilisateur",
        "statsTotal": "Total",
        "statsSuperusers": "Superutilisateurs",
        "statsOwners": "Propriétaires",
        "statsActive": "Actif",
        "loadError": "Échec du chargement des utilisateurs",
        "empty": "Aucun utilisateur ne correspond aux filtres actuels"
      },
      "organizations": {
        "title": "Gestion des organisations",
        "subtitle": "Voir et gérer toutes les organisations du système",
        "searchPlaceholder": "Rechercher par nom ou description d'organisation...",
        "sectionTitle": "Organisations",
        "loading": "Chargement des organisations...",
        "empty": "Aucune organisation trouvée",
        "loadError": "Échec du chargement des organisations",
        "restored": "Organisation restaurée",
        "restoreError": "Échec de la restauration de l'organisation",
        "owner": "Propriétaire",
        "created": "Créé",
        "deletedBadge": "Supprimé",
        "activeBadge": "Actif",
        "agentSubscription": "Abonnement de l'agent",
        "statsTotal": "Total des organisations",
        "statsActive": "Actif",
        "statsProjects": "Projets",
        "statsForms": "Formulaires"
      },
      "projects": {
        "title": "Gestion des projets",
        "subtitle": "Voir et gérer tous les projets du système",
        "searchPlaceholder": "Rechercher par nom ou description de projet...",
        "sectionTitle": "Projets",
        "loading": "Chargement des projets...",
        "empty": "Aucun projet trouvé",
        "loadError": "Échec du chargement des projets",
        "archived": "Projet archivé",
        "unarchived": "Projet restauré",
        "archiveError": "Échec de l'archivage du projet",
        "unarchiveError": "Échec de la restauration du projet",
        "created": "Créé",
        "archivedBadge": "Archivé",
        "activeBadge": "Actif",
        "statsTotal": "Total des projets",
        "statsActive": "Actif",
        "statsArchived": "Archivé",
        "statsForms": "Formulaires"
      },
      "forms": {
        "title": "Gestion des formulaires",
        "subtitle": "Voir et gérer tous les formulaires du système",
        "searchPlaceholder": "Rechercher par nom de formulaire ou ID XML...",
        "sectionTitle": "Formulaires",
        "loading": "Chargement des formulaires...",
        "empty": "Aucun formulaire trouvé",
        "loadError": "Échec du chargement des formulaires",
        "deletedToast": "Formulaire marqué comme supprimé",
        "restoredToast": "Formulaire restauré",
        "deleteError": "Échec de la suppression du formulaire",
        "restoreError": "Échec de la restauration du formulaire",
        "created": "Créé",
        "deletedBadge": "Supprimé",
        "activeBadge": "Actif",
        "importedBadge": "Importé",
        "statsTotal": "Total des formulaires",
        "statsActive": "Actif",
        "statsDeleted": "Supprimé",
        "statsImported": "Importé"
      },
      "permissionGroups": {
        "title": "Groupes de permissions",
        "subtitle": "Gérer les groupes de permissions et les attribuer aux utilisateurs",
        "createGroup": "Créer un groupe",
        "sectionTitle": "Groupes de permissions",
        "searchPlaceholder": "Rechercher des groupes...",
        "emptyFilter": "Aucun groupe ne correspond à la recherche actuelle",
        "restoreError": "Échec de la restauration du groupe de permissions",
        "deleteError": "Échec de la suppression du groupe de permissions",
        "emptyTitle": "Aucun groupe de permissions trouvé",
        "emptyBody": "Créez le premier groupe de permissions pour commencer",
        "deleteTitle": "Supprimer le groupe",
        "deleteMessage": "Êtes-vous sûr de vouloir supprimer le groupe \"{name}\" ? Cette action est irréversible.",
        "restoreTitle": "Restaurer",
        "users": "Utilisateurs",
        "statsTotal": "Total des groupes",
        "statsActive": "Groupes actifs",
        "statsAssignments": "Assignations",
        "loadError": "Échec du chargement des groupes de permissions",
        "restored": "Groupe \"{name}\" restauré",
        "deleted": "Groupe de permissions supprimé",
        "saved": "Groupe de permissions sauvegardé",
        "modal": {
          "createTitle": "Create permission group",
          "editTitle": "Edit permission group",
          "createHeader": "New permission group",
          "editHeader": "Edit group",
          "createSubtitle": "Create a new group with a set of roles",
          "editSubtitle": "Modify permission group parameters",
          "nameLabel": "Group name",
          "namePlaceholder": "Enter group name",
          "descriptionLabel": "Description",
          "descriptionPlaceholder": "Enter group description",
          "activeLabel": "Group is active",
          "activeHint": "Inactive groups cannot be assigned to users",
          "rolesTitle": "Group roles",
          "rolesSubtitle": "Select roles to include in this group",
          "selectAtLeastOneRole": "Select at least one role",
          "selectedRolesTitle": "Selected roles",
          "clickToRemove": "Click on a role to remove it from the group",
          "validation": {
            "nameRequired": "Name is required",
            "nameMinLength": "Name must contain at least 2 characters",
            "nameMaxLength": "Name must not exceed 50 characters"
          },
          "toasts": {
            "createSuccess": "Permission group created successfully",
            "updateSuccess": "Permission group updated successfully",
            "saveError": "Error saving permission group"
          }
        },
        "groupUsersModal": {
          "title": "Users in group \"{name}\"",
          "noDescription": "No description available",
          "rolesCount": "Roles in group: {count}",
          "usersCount": "Users in group ({count})",
          "empty": "No users in this group",
          "noName": "Unnamed",
          "active": "Active",
          "inactive": "Inactive",
          "superuser": "Superuser",
          "owner": "Owner",
          "loadError": "Error loading group users"
        }
      },
      "globalOdkServers": {
        "title": "Serveurs ODK globaux",
        "subtitle": "Créer et gérer les serveurs ODK au niveau du système",
        "createServer": "Créer un serveur",
        "statsTotal": "Total des serveurs",
        "statsTotalHint": "{count} (+{active} actifs)",
        "statsGlobal": "Globaux",
        "statsDefault": "Par défaut",
        "testTitle": "Résultat du test de connexion",
        "testOk": "Connexion réussie",
        "testFail": "Connexion échouée",
        "testMethod": "Méthode :",
        "testProjects": "Nombre de projets :",
        "testing": "Test de connexion...",
        "refreshTokenTitle": "Actualiser le jeton API",
        "refreshTokenBody": "Saisissez le mot de passe pour actualiser le jeton API pour le serveur",
        "password": "Mot de passe",
        "passwordPlaceholder": "Saisir le mot de passe",
        "refreshTokenAction": "Actualiser le jeton",
        "requiredField": "Ce champ est obligatoire",
        "searchPlaceholder": "Rechercher par nom, URL ou nom d'utilisateur...",
        "empty": "Aucun serveur ODK global",
        "emptyHint": "Créez le premier serveur ODK global pour commencer.",
        "emptyFilter": "Aucun serveur ne correspond à la recherche actuelle",
        "defaultBadge": "Par défaut",
        "columns": {
          "server": "Serveur",
          "user": "Utilisateur",
          "visibility": "Visibilité"
        },
        "visibility": {
          "GLOBAL": "Global",
          "ORGANIZATION": "Organisation",
          "SHARED": "Partagé"
        },
        "actions": {
          "test": "Tester la connexion",
          "refreshToken": "Actualiser le jeton",
          "setDefault": "Définir par défaut"
        },
        "deleteTitle": "Supprimer le serveur",
        "deleteMessage": "Supprimer le serveur \"{name}\" ? Cette action est irréversible.",
        "setDefaultTitle": "Définir le serveur par défaut",
        "setDefaultMessage": "Définir \"{name}\" comme serveur ODK global par défaut ?",
        "setDefaultConfirm": "Définir par défaut",
        "toastCreated": "Serveur créé",
        "toastUpdated": "Serveur mis à jour",
        "toastDeleted": "Serveur supprimé",
        "toastTestOk": "Connexion réussie",
        "toastTokenRefreshed": "Jeton API actualisé",
        "toastDefaultSet": "Serveur global par défaut mis à jour",
        "form": {
          "createTitle": "Create global ODK server",
          "editTitle": "Edit global ODK server",
          "nameLabel": "Server name",
          "namePlaceholder": "Enter server name",
          "urlLabel": "Server URL",
          "urlPlaceholder": "https://example.com",
          "usernameLabel": "Username",
          "usernamePlaceholder": "Enter username",
          "passwordLabel": "Password",
          "passwordPlaceholder": "Enter password",
          "descriptionLabel": "Description",
          "descriptionPlaceholder": "Server description (optional)",
          "globalDefaultLabel": "Global default server",
          "activeLabel": "Active server",
          "updateButton": "Update"
        }
      },
      "subscriptions": {
        "title": "Abonnements de facturation",
        "subtitle": "Plans de facturation et de paiement SaaS (pas les quotas de Hermes Agent)",
        "stubBadge": "Bientôt disponible",
        "stubBody": "Les abonnements de facturation et de paiement sont en cours de développement. Cette page gérera les plans commerciaux lorsque la facturation sera disponible.",
        "stubAgentHint": "Les niveaux, quotas et indicateurs de fonctionnalité de Hermes Agent sont gérés sous Intégrations → Hermes Agent → Abonnements.",
        "openAgentSubscriptions": "Ouvrir les abonnements de l'agent"
      },
      "audit": {
        "title": "Audit des actions",
        "subtitle": "Journal des actions administratives des superutilisateurs",
        "loadError": "Échec du chargement du journal d'audit.",
        "empty": "Aucun enregistrement d'audit pour le moment",
        "time": "Temps",
        "user": "Utilisateur",
        "action": "Action",
        "details": "Détails",
        "emptyFilter": "Aucun enregistrement ne correspond à la recherche actuelle",
        "searchPlaceholder": "Rechercher par utilisateur, action ou détails...",
        "actionKey": "Clé d'action",
        "detailTitle": "Entrée d'audit"
      },
      "system": {
        "title": "Santé du système",
        "subtitle": "Diagnostics d'infrastructure — statut, latence et détails d'exécution",
        "loadError": "Échec du chargement du statut du système.",
        "serverInfo": "Détails d'exécution",
        "version": "Version",
        "uptime": "Temps de fonctionnement du processus",
        "dbConnections": "Connexions SGBD (actives)",
        "dbPool": "Taille du pool SGBD",
        "components": {
          "server": "Serveur",
          "database": "Base de données",
          "redis": "Redis",
          "api": "API",
          "agent": "Agent Hermes"
        },
        "attentionTitle": "Nécessite une attention",
        "attentionComponent": "{component} : {status}",
        "openAgent": "Ouvrir l'Agent",
        "componentsTitle": "Composants",
        "dbLatency": "Latence SGBD",
        "apiLatency": "Latence API"
      },
      "analytics": {
        "title": "Tableau de bord analytique",
        "subtitle": "Analytique système et utilisateurs",
        "loadError": "Échec du chargement de l'analytique. Affichage de zéros.",
        "totalUsers": "Total des utilisateurs",
        "thisMonth": "+{count} ce mois",
        "organizations": "Organisations",
        "growthPct": "{pct}% de croissance",
        "totalProjects": "Total des projets",
        "totalForms": "Total des formulaires",
        "submissions": "Soumissions",
        "userGrowth": "Croissance des utilisateurs (par mois)",
        "orgActivity": "Activité des organisations (par projets)",
        "noData": "Aucune donnée",
        "topOrgs": "Top des organisations",
        "projectsCount": "{count} projets",
        "noOrgs": "Aucune organisation",
        "recentActivity": "Activité récente",
        "noRecent": "Aucune activité récente",
        "systemHealth": "Santé du système",
        "resources": "Utilisation des ressources",
        "orgs": "Organisations",
        "projects": "Projets",
        "forms": "Formulaires",
        "health": {
          "api": "API",
          "database": "Base de données",
          "redis": "Redis",
          "websocket": "WebSocket",
          "agent": "Agent Hermes"
        }
      },
      "roles": {
        "title": "Rôles et permissions",
        "subtitle": "Catalogue des rôles plateforme — briques pour les groupes de permissions",
        "searchPlaceholder": "Rechercher des rôles...",
        "loadError": "Impossible de charger les rôles.",
        "emptyTitle": "Aucun rôle trouvé",
        "emptyFilter": "Aucun rôle ne correspond à la recherche",
        "openGroups": "Groupes de permissions",
        "system": "Système",
        "custom": "Personnalisé",
        "unused": "Non utilisé dans un groupe",
        "columns": {
          "role": "Rôle",
          "description": "Description",
          "usedIn": "Utilisé dans des groupes",
          "type": "Type"
        },
        "labels": {
          "project_member": "Membre du projet"
        },
        "descriptions": {
          "fallback": "Aucune description disponible.",
          "manager": "Gestion complète du projet et supervision qualité.",
          "project_member": "Accès minimal au projet — nom et formulaires, sans données de soumission.",
          "data_viewer": "Accès en lecture seule aux soumissions, monitoring et revue QC.",
          "data_collector": "Collecter et soumettre des données de terrain.",
          "data_downloader": "Exporter et télécharger les données de soumission.",
          "data_analyst": "Opérations QC et analyse des données.",
          "form_designer": "Créer et gérer des formulaires XLSForm.",
          "qc_editor": "Modifier les résultats et constats QC."
        }
      }
    },
    "dashboard": {
      "title": "Aperçu",
      "subtitle": "Pouls de la plateforme et activité administrative récente",
      "errors": {
        "stats": "Impossible de charger les métriques du système. Affichage de zéros.",
        "health": "Impossible de charger la santé du système.",
        "activities": "Impossible de charger l'activité récente."
      },
      "attention": {
        "title": "Nécessite une attention",
        "server": "Le serveur signale un état non sain.",
        "database": "La base de données signale un état non sain.",
        "redis": "Redis signale un état non sain.",
        "api": "L'API signale un état non sain.",
        "agent": "Statut de l'Agent Hermes : {status}.",
        "failedLogins": "{count} tentatives de connexion échouées au cours des 24 dernières heures.",
        "openSystem": "Ouvrir le Système",
        "openAgent": "Ouvrir l'Agent",
        "openAudit": "Ouvrir l'Audit"
      },
      "sections": {
        "metrics": "Répertoire",
        "health": "Santé",
        "activity": "Activité récente"
      },
      "metrics": {
        "users": "Utilisateurs",
        "usersHint": "+{count} aujourd'hui",
        "orgs": "Organisations",
        "orgsHint": "+{count} cette semaine",
        "projects": "Projets",
        "projectsHint": "{count} actifs",
        "failedLogins": "Connexions échouées",
        "failedLoginsHint": "24 dernières heures"
      },
      "health": {
        "server": "Serveur",
        "database": "Base de données",
        "redis": "Redis",
        "api": "API",
        "agent": "Agent Hermes",
        "connections": "{count} connexions",
        "latency": "{ms} ms",
        "agentHint": "{count} req aujourd'hui"
      },
      "activity": {
        "viewAll": "Voir l'audit",
        "empty": "Aucune activité administrative récente"
      }
    }
  },
  "agent": {
    "common": {
      "loading": "Chargement de l'abonnement de l'agent...",
      "working": "L'agent est en cours de travail..."
    },
    "features": {
      "reports": "Rapports",
      "qc": "Assistant QC",
      "xlsform": "XLSForm",
      "share_links": "Share links",
      "auto_reports": "Auto-reports",
      "qc_rules": "QC rules"
    },
    "errors": {
      "generic": "Erreur lors de l'appel de l'agent.",
      "endpointNotFound": "Cette fonctionnalité de l'agent n'est pas disponible sur le backend en cours d'exécution. Redémarrez le serveur backend dev (.\\scripts\\dev.ps1).",
      "timeout": "L'agent n'a pas répondu dans le temps. L'assistant XLSForm peut prendre jusqu'à 10 minutes — réessayer.",
      "featureUnavailable": "Cette fonctionnalité n'est pas disponible sur votre plan.",
      "quotaExceeded": "Quota de l'agent dépassé pour cette période.",
      "disabled": "L'agent AI est temporairement désactivé.",
      "mcpUnavailable": "Hermes ne peut pas voir les outils MCP udacapi. Enregistrez MCP sur CT253 (grant-udacapi-mcp.sh) et vérifiez le relay :8101 → backend :8100. Voir runbooks/hermes-udacapi-agent-integration.md."
    },
    "quota": {
      "exceededTitle": {
        "monthly": {
          "requests": "Limite mensuelle de requêtes atteinte",
          "tokens": "Limite mensuelle de tokens atteinte"
        },
        "five_hour": {
          "requests": "Limite de requêtes sur 5 heures atteinte",
          "tokens": "Limite de tokens sur 5 heures atteinte"
        },
        "weekly": {
          "requests": "Limite hebdomadaire de requêtes atteinte",
          "tokens": "Limite hebdomadaire de tokens atteinte"
        }
      },
      "usageLine": "{used} sur {limit} utilisés",
      "resetsAt": "Disponible à nouveau {relative} ({absolute})",
      "resetsUnknown": "Réessayez plus tard ou contactez votre administrateur pour augmenter les limites.",
      "viewSubscription": "Voir les détails de quota",
      "sendBlocked": "Quota de l'agent épuisé — attendez la réinitialisation du limite.",
      "nearLimit": "Quota de l'agent presque épuisée ({pct}%)."
    },
    "upgrade": {
      "lockedTitle": "Fonctionnalité bloquée",
      "lockedDescription": "\"{feature}\" est disponible sur le plan {tier} et au-dessus."
    },
    "subscription": {
      "sectionTitle": "Agent AI",
      "sectionDescription": "Le niveau, les quotas et les fonctionnalités activées de l'agent de votre organisation.",
      "currentTier": "Niveau actuel",
      "active": "Actif",
      "inactive": "Inactif",
      "features": "Fonctionnalités activées",
      "tier": "Niveau",
      "capabilities": "Fonctionnalités",
      "billingPeriod": "Début de la période de facturation",
      "requests": "Requêtes pour cette période",
      "requests_5h": "Requêtes (dernières 5h)",
      "requests_weekly": "Requêtes (dernière semaine)",
      "requests_badge": "req.",
      "requests_5h_badge": "req. (5h)",
      "requests_weekly_badge": "req. (sem.)",
      "tokens": "Tokens pour cette période",
      "tokens_5h": "Tokens (dernières 5h)",
      "tokens_weekly": "Tokens (dernière semaine)",
      "nearQuotaTitle": "Limite de quota proche",
      "nearQuotaDescription": "Plus de 80% de la quota mensuelle est utilisée. Contactez votre administrateur pour augmenter les limites.",
      "tiers": {
        "free": "Gratuit",
        "pro": "Pro",
        "enterprise": "Entreprise"
      },
      "trialActive": "Pro trial active until {date}. After that you stay on Free with plan limits.",
      "submissionsSoftExceeded": "Submission volume is above your plan soft limit. Contact us to upgrade — field sync is not blocked."
    },
    "report": {
      "title": "Rapport AI pour PM",
      "description": "Résumé des soumissions préparé par l'agent AI UDA.",
      "period": "Période (jours)",
      "generate": "Générer le rapport",
      "generating": "L'agent est en train de préparer le rapport...",
      "empty": "Cliquez sur \"Générer le rapport\" pour obtenir un résumé.",
      "modeSummary": "Résumé",
      "modeAnalytical": "Analytique",
      "modeScheduled": "Par modèle",
      "quotaExceeded": "Quota de l'agent dépassé pour cette période.",
      "featureUnavailable": "Les rapports AI ne sont pas disponibles sur votre plan.",
      "error": "Erreur lors de la récupération du rapport de l'agent.",
      "healthAlerts": "Notes de santé du formulaire",
      "copy": "Copier le rapport",
      "copied": "Copié",
      "copyFailed": "Impossible de copier dans le presse-papiers.",
      "viewFormatted": "Formaté",
      "viewRaw": "Markdown",
      "auto": {
        "latest": "Dernier",
        "history": "Historique",
        "generateNow": "Générer maintenant",
        "manageTemplates": "Gérer les modèles",
        "selectTemplate": "Modèle",
        "latestEmpty": "Aucun rapport de modèle complété encore. Choisissez un modèle et cliquez sur Générer maintenant.",
        "historyEmpty": "Aucune exécution de rapport encore.",
        "view": "Voir",
        "viewTitle": "Rapport",
        "close": "Fermer",
        "generating": "Génération du rapport planifié...",
        "done": "Rapport prêt.",
        "statusLabel": "Statut : {status}",
        "emptyResult": "Le rapport est terminé mais n'a retourné aucun contenu.",
        "runFailed": "La génération du rapport a échoué.",
        "timeout": "Le rapport a pris trop de temps. Réessayez plus tard.",
        "noContent": "Aucun contenu de rapport disponible.",
        "unknownTemplate": "Modèle inconnu",
        "trigger": {
          "scheduled": "Planifié",
          "event": "Événement",
          "manual": "Manuel"
        },
        "status": {
          "pending": "En attente",
          "running": "En cours",
          "done": "Terminé",
          "failed": "Échoué"
        }
      },
      "templates": {
        "title": "Modèles de rapports",
        "subtitle": "Configurez les planifications et les prompts IA pour cette organisation.",
        "create": "Nouveau modèle",
        "createTitle": "Créer un modèle de rapport",
        "edit": "Modifier",
        "editTitle": "Modifier le modèle de rapport",
        "formSubtitle": "Définissez le contenu du rapport, sa planification et ses destinataires.",
        "sections": {
          "content": "Contenu du rapport",
          "schedule": "Planification",
          "delivery": "Diffusion et portée"
        },
        "seed": "Charger les valeurs par défaut",
        "seeded": "{count} modèle(s) ajouté(s).",
        "empty": "Aucun modèle encore. Chargez les valeurs par défaut ou créez-en un.",
        "active": "Actif",
        "inactive": "Inactif",
        "cron": "Planification",
        "sendByEmail": "Envoyer par e-mail",
        "deactivate": "Désactiver",
        "deactivated": "Modèle désactivé.",
        "activate": "Activer",
        "activated": "Modèle activé.",
        "save": "Enregistrer",
        "saved": "Modèle enregistré.",
        "saveError": "Impossible d'enregistrer le modèle.",
        "loadError": "Impossible de charger les modèles de rapport.",
        "validationRequired": "Nom et prompt requis.",
        "recipientsPlaceholder": "Sélectionner les membres de l'organisation",
        "recipientsRequired": "Sélectionnez au moins un destinataire si l'e-mail est activé.",
        "promptHint": "L'accès aux données de l'organisation, aux formulaires sélectionnés et à la période est ajouté automatiquement.",
        "allFormsPlaceholder": "Tous les formulaires (laisser vide)",
        "advancedMode": "Prompt personnalisé (avancé, Jinja2)",
        "fields": {
          "name": "Nom",
          "audience": "Public",
          "prompt": "Instructions du rapport",
          "responseLanguage": "Langue de réponse",
          "recipients": "Destinataires",
          "formScope": "Formulaires"
        },
        "schedule": {
          "label": "Planification",
          "none": "Aucune planification",
          "daily": "Quotidien",
          "weekly": "Hebdomadaire",
          "monthly": "Mensuel",
          "custom": "Personnalisé (cron)",
          "time": "Heure",
          "weekday": "Jour de la semaine",
          "dayOfMonth": "Jour du mois",
          "customCron": "Expression cron",
          "humanDaily": "Chaque jour à {time}",
          "humanWeekly": "Chaque {weekday} à {time}",
          "humanMonthly": "Le {day} de chaque mois à {time}",
          "weekdays": {
            "0": "Dimanche",
            "1": "Lundi",
            "2": "Mardi",
            "3": "Mercredi",
            "4": "Jeudi",
            "5": "Vendredi",
            "6": "Samedi"
          }
        },
        "audience": {
          "pm": "Chef de projet",
          "field_coord": "Coordonnateur terrain",
          "statistician": "Statisticien",
          "executive": "Exécutif"
        }
      }
    },
    "chat": {
      "modeAsk": "Demander à l'agent",
      "description": "Demandez des questions sur le schéma du formulaire, les soumissions, les analyses, les règles QC et le statut de synchronisation. Les réponses sont basées sur des données en temps réel; les soumissions d'exemple peuvent contenir des champs personnels.",
      "question": "Votre question",
      "placeholder": "e.g. Combien de soumissions dans les 7 derniers jours ? Quels champs a ce formulaire ?",
      "send": "Envoyer",
      "empty": "Demandez une question sur les données de ce formulaire.",
      "you": "Vous",
      "agent": "Agent",
      "generating": "L'agent est en train de rechercher les données du formulaire...",
      "sendHint": "Entrer pour envoyer · Shift+Enter pour une nouvelle ligne"
    },
    "analytical": {
      "generate": "Exécuter le rapport analytique",
      "empty": "Exécuter un rapport analytique pour une analyse approfondie du formulaire.",
      "queued": "Rapport en attente...",
      "status": "Statut: {status}",
      "done": "Rapport prêt.",
      "failed": "Erreur lors de la génération du rapport analytique.",
      "emptyResult": "Le rapport est terminé mais n'a retourné aucun contenu.",
      "timeout": "Le rapport analytique a pris trop longtemps. Vérifiez que le worker de rapports de l'agent est en cours d'exécution.",
      "workerHint": "Le job est toujours en attente. Démarrez le service agent-reports-worker (docker compose up -d agent-reports-worker) et réessayer."
    },
    "qc": {
      "title": "Assistant QC AI",
      "description": "Décrivez une vérification en langage simple — l'agent écrira une règle QC.",
      "checkDescription": "Description de la vérification",
      "checkPlaceholder": "e.g. l'âge du répondant doit être entre 18 et 65",
      "suggest": "Suggérer une règle",
      "generating": "L'agent est en train de rédiger une règle...",
      "applyDraft": "Appliquer le brouillon au formulaire",
      "draftApplied": "Brouillon appliqué au formulaire.",
      "draftPreview": "Règle suggérée",
      "viewRawResponse": "Voir la réponse complète de l'agent",
      "sendHint": "Entrer pour suggérer · Shift+Enter pour une nouvelle ligne",
      "noDraftParsed": "Impossible de parser un brouillon de règle JSON de la réponse de l'agent.",
      "validationWarnings": "Notes de validation ({count}):",
      "starterPack": {
        "title": "Règles de démarrage QC",
        "description": "Revisez le formulaire et obtenez un ensemble de règles suggérées pour commencer la validation.",
        "focus": "Focus",
        "focusAll": "Mix balanceé",
        "focusRequired": "Champs requis uniquement",
        "focusConstraints": "Contraintes uniquement",
        "maxRules": "Max règles",
        "suggest": "Suggérer des règles de démarrage",
        "generating": "Revision du formulaire et rédaction des règles...",
        "apply": "Appliquer cette règle",
        "empty": "Aucun brouillon de règle valide n'a été retourné. Réessayer ou utiliser la suggestion de règle unique ci-dessus.",
        "skippedHint": "{count} règle(s) suggérée(s) ont été ignorée(s) (duplicata, invalide, ou dépassée la limite)."
      }
    },
    "xlsform": {
      "openButton": "IA XLSForm",
      "title": "Assistant IA XLSForm",
      "description": "Téléchargez un fichier de questions ou décrivez la tâche — l'agent écrira, testera et demandera confirmation de publication.",
      "instruction": "Instruction pour l'agent",
      "instructionPlaceholder": "e.g. créer un formulaire d'enquête de satisfaction avec 5 questions",
      "empty": "Décrivez quel formulaire vous avez besoin ou téléchargez un fichier — l'agent écrira et testera.",
      "send": "Envoyer",
      "sendHint": "Entrer pour envoyer · Shift+Enter pour une nouvelle ligne",
      "working": "L'agent est en train de travailler sur la tâche...",
      "you": "Vous",
      "agent": "Agent",
      "publishTitle": "Confirmation de publication",
      "publishDescription": "L'agent a demandé la publication d'un brouillon. Confirmez manuellement — la publication ne peut pas continuer sans confirmation.",
      "formId": "ID du formulaire (xmlFormId)",
      "versionOptional": "Version (optionnel)",
      "confirmPublish": "Confirmer la publication",
      "upload": {
        "hint": "Joindre Excel/CSV, Word, ou texte avec vos questions (max 5 MB)",
        "attachAria": "Joindre un fichier",
        "removeAttachment": "Retirer la pièce jointe",
        "selected": "Fichier: {name}",
        "attachmentPrefix": "[file: {name}]"
      },
      "session": {
        "resumeBanner": "Vous avez une session AI XLSForm non terminée (brouillon: {formId})",
        "resumeButton": "Continuer",
        "startNewButton": "Nouvelle session",
        "dismissButton": "Ignorer",
        "dismissError": "Impossible d'ignorer la session. Réessayez.",
        "historyButton": "Sessions précédentes",
        "historyTitle": "Sessions AI XLSForm",
        "historyHint": "Sessions des 7 derniers jours. Reprenez un brouillon ou consultez une session publiée.",
        "historyEmpty": "Aucune session précédente pour ce projet.",
        "historyFormColumn": "Brouillon",
        "historyStatusColumn": "Statut",
        "historyUpdatedColumn": "Mis à jour",
        "historyMessagesColumn": "Messages",
        "historyActionsColumn": "Actions",
        "continueButton": "Continuer",
        "viewButton": "Voir",
        "continueError": "Impossible de reprendre la session. Réessayez.",
        "readOnlyHint": "Cette session a été publiée. Vous pouvez consulter l'historique mais pas envoyer de nouveaux messages.",
        "draftUnknown": "sans nom",
        "status": {
          "active": "Actif",
          "discarded": "Ignorée",
          "failed": "Échouée",
          "published": "Publiée"
        }
      },
      "job": {
        "canClose": "Vous pouvez fermer cette fenêtre — votre session continuera en arrière-plan.",
        "elapsed": "En cours de travail… {time}",
        "agentWorking": "L'agent est en train de travailler sur votre demande (LLM et outils MCP). Cette étape peut prendre plusieurs minutes.",
        "longWait": "Toujours en cours de travail — vérifiez que le proxy LLM et le relay Hermes MCP sont en bon état si cela prend plus de 10 minutes.",
        "timeout": "L'assistant de formulaire n'a pas terminé à temps. La session en échec a été réinitialisée ; réessayez dans une nouvelle session.",
        "failed": "L'assistant de formulaire a échoué. Réessayer.",
        "phases": {
          "queued": "En attente",
          "planning": "Analyse de votre demande",
          "editing": "Modification des questions du formulaire",
          "uploading_draft": "Création du brouillon de formulaire",
          "testing_draft": "Test du brouillon",
          "finalizing": "Préparation de la réponse",
          "completed": "Terminé"
        },
        "queuedFallback": "Le worker n'a pas encore pris le job — le serveur réessaiera dans quelques instants."
      },
      "preview": {
        "tabChat": "Discussion",
        "tabPreview": "Aperçu",
        "loading": "Chargement de l'aperçu du formulaire…",
        "empty": "Aucun brouillon à aperçu encore. Demandez à l'assistant de créer ou modifier le formulaire.",
        "error": "Impossible de charger l'aperçu du formulaire.",
        "submitError": "Impossible d'envoyer la soumission de test."
      }
    },
    "entitlement": {
      "title": "Upgrade required",
      "body": "This capability is not included in your current organization plan. Contact us to upgrade to Pro or Enterprise.",
      "contactUs": "Contact us to upgrade your plan."
    }
  },
  "websocket": {
    "notifications": {
      "syncComplete": "Synchronisation terminée: {formName}. {count} sur {total} enregistrements traités",
      "syncError": "Erreur de synchronisation: {formName}. {error}",
      "formStatusChange": "Statut du formulaire modifié: {formName} ({oldStatus} → {newStatus})",
      "schedulerUpdate": "Planificateur: {status}. Tâches actives: {activeJobs}/{totalJobs}",
      "qcValidationComplete": "Validation QC terminée: {instanceId}. Règles: {totalRules}, réussies: {passedRules}, erreurs: {errorRules}, avertissements: {warningRules}",
      "projectStatusSummary": "Changements critiques: {errorProjects} projets avec erreurs, {errorForms} formulaires avec erreurs sur {totalProjects} projets et {totalForms} formulaires"
    },
    "connection": {
      "connected": "WebSocket connecté",
      "disconnected": "WebSocket déconnecté",
      "reconnecting": "Reconnexion...",
      "error": "Erreur WebSocket: {error}",
      "maxRetriesReached": "Nombre maximum de tentatives de reconnexion atteint"
    },
    "connected": "Connecté",
    "disconnected": "Déconnecté",
    "realTimeUpdates": "Mises à jour en temps réel"
  },
  "buttonSelect": {
    "dark": "Sombre",
    "light": "Clair"
  },
  "odkOptions": {
    "themes": {
      "light": "Clair",
      "dark": "Sombre"
    },
    "navigation": {
      "swipe": "Glisser",
      "buttons": "Boutons",
      "swipe_buttons": "Glisser + Boutons"
    },
    "formUpdate": {
      "manual": "Manuel",
      "previously_downloaded": "Téléchargé précédemment",
      "match_exactly": "Correspondre exactement"
    },
    "periodicUpdates": {
      "every_fifteen_minutes": "Toutes les 15 minutes",
      "every_one_hour": "Toutes les heures",
      "every_six_hours": "Toutes les 6 heures",
      "every_24_hours": "Toutes les 24 heures"
    },
    "autosend": {
      "off": "Désactivé",
      "wifi_only": "Wi‑Fi uniquement",
      "cellular_only": "Données mobiles uniquement",
      "wifi_and_cellular": "Wi‑Fi et données mobiles"
    },
    "constraintBehavior": {
      "on_swipe": "Au glissement",
      "on_finalize": "À la finalisation"
    },
    "imageSizes": {
      "original": "Original",
      "very_small": "Très petit",
      "small": "Petit",
      "medium": "Moyen",
      "large": "Grand"
    },
    "guidanceHint": {
      "no": "Non",
      "yes": "Oui",
      "yes_collapsed": "Oui (réduit)"
    },
    "basemap": {
      "google": "Google",
      "mapbox": "Mapbox",
      "osm": "OSM",
      "usgs": "USGS",
      "carto": "Carto"
    },
    "mapStyles": {
      "normal": "Normal",
      "terrain": "Terrain",
      "hybrid": "Hybride",
      "satellite": "Satellite",
      "light": "Clair",
      "dark": "Sombre",
      "satellite_streets": "Satellite + rues",
      "outdoors": "Extérieur",
      "topographic": "Topographique",
      "positron": "Positron",
      "dark_matter": "Matière sombre"
    },
    "fontSizes": {
      "small": "Petit",
      "normal": "Normal",
      "large": "Grand",
      "xl": "XL",
      "xxl": "XXL"
    }
  },
  "users": {
    "title": "Gestion des utilisateurs",
    "subtitle": "Gérez les membres de l'organisation, filtrez par activité et mettez à jour les enregistrements d'accès.",
    "searchUser": "Rechercher un utilisateur",
    "addUser": "Ajouter un utilisateur",
    "editUser": "Modifier l'utilisateur",
    "deleteUser": "Supprimer l'utilisateur",
    "firstName": "Prénom",
    "lastName": "Nom de famille",
    "fullName": "Nom complet",
    "email": "Email",
    "password": "Mot de passe",
    "confirmPassword": "Confirmer le mot de passe",
    "enterEmail": "Saisir l'email",
    "userCreated": "Utilisateur créé avec succès",
    "userUpdated": "Utilisateur mis à jour avec succès",
    "userDeleted": "Utilisateur supprimé avec succès",
    "confirmDeleteUser": "Êtes-vous sûr de vouloir supprimer cet utilisateur ?",
    "projectSelection": {
      "archived": "Archivé",
      "noProjects": "Aucun projet disponible",
      "noProjectsDescription": "Aucun projet disponible pour l'assignation",
      "errorLoadingProjects": "Erreur lors du chargement des projets"
    },
    "admin": "Administrateur",
    "data_collector": "Collecteur de données",
    "supervisor": "Superviseur",
    "user": "Utilisateur",
    "owner": "Propriétaire",
    "isClient": "Client",
    "active": "Actif",
    "inactive": "Inactif",
    "refresh": "Actualiser",
    "unsavedChanges": "Le formulaire contient des modifications non enregistrées. Êtes-vous sûr de vouloir le fermer ?",
    "validation": {
      "passwordRequired": "Le mot de passe est requis",
      "passwordMinLength": "Le mot de passe doit contenir au moins 8 caractères",
      "confirmPasswordRequired": "Veuillez confirmer le mot de passe",
      "passwordsDontMatch": "Les mots de passe ne correspondent pas"
    },
    "editUserDescription": "Mettre à jour les détails de l'utilisateur",
    "addUserDescription": "Créer un nouvel utilisateur dans le système",
    "basicInformation": "Informations de base",
    "fullNamePlaceholder": "Entrez le nom complet",
    "passwordSettings": "Paramètres du mot de passe",
    "passwordPlaceholder": "Entrez le mot de passe",
    "confirmPasswordPlaceholder": "Confirmez le mot de passe",
    "passwordHelp": "Le mot de passe doit comporter au moins 8 caractères",
    "userSettings": "Paramètres utilisateur",
    "clientUserDescription": "L'utilisateur client a un accès limité",
    "inactiveUserDescription": "Les utilisateurs inactifs ne peuvent pas se connecter au système",
    "noName": "Sans nom"
  },
  "user": {
    "system": "Système",
    "account": "Compte",
    "explore": "Explorer",
    "profile": "Profil",
    "logout": "Déconnexion",
    "settings": "Paramètres",
    "projects": "Projets",
    "faq": "Aide",
    "helpAndSupport": "Aide et support",
    "administration": "Administration",
    "help": "Aide"
  },
  "odkSync": {
    "dashboard": {
      "title": "Tableau de Bord de Synchronisation ODK"
    },
    "workbench": {
      "contextHint": "Surveillez l'ingestion des données depuis les serveurs ODK et gérez les curseurs de synchronisation dans toute votre organisation.",
      "live": "Mises à jour en temps réel",
      "reconnect": "Reconnecter",
      "loading": "Chargement des données de synchronisation…",
      "schedulerPill": "Planificateur",
      "schedulerActive": "Actif",
      "schedulerPaused": "En pause",
      "schedulerStopped": "Arrêté",
      "statusLive": "En temps réel",
      "statusOffline": "Déconnecté",
      "statusSchedulerActive": "Actif",
      "statusSchedulerPaused": "En pause",
      "statusSchedulerStopped": "Arrêté",
      "createShort": "Nouveau",
      "pipeline": {
        "ariaLabel": "Statut de la pipeline de synchronisation",
        "scheduler": "Planificateur",
        "schedulerActive": "En cours d'exécution selon le programme",
        "schedulerPaused": "En pause — soumissions non synchronisées",
        "pull": "Dernière extraction",
        "cursors": "Curseurs",
        "cursorsHint": "{count} formulaires suivis",
        "cursorsEmpty": "Aucun curseur pour le moment"
      }
    },
    "table": {
      "emptyState": "Aucun curseur de synchronisation pour le moment. Créez-en un pour commencer à extraire les soumissions."
    },
    "scheduler": {
      "title": "Planificateur de Synchronisation",
      "pauseScheduler": "Pause du Planificateur",
      "resumeScheduler": "Reprendre le Planificateur",
      "pausedMessage": "La synchronisation des données ODK est actuellement en pause. Les nouvelles soumissions ne seront pas synchronisées jusqu'à la reprise."
    },
    "managerScope": {
      "title": "Affichage des données synchronisées",
      "message": "Vous êtes en train de voir les données de synchronisation pour {count} projet(s) que vous gérez. Vous pouvez voir et contrôler la synchronisation pour les projets où vous avez le rôle de gestionnaire."
    },
    "statistics": {
      "title": "Statistiques de Synchronisation",
      "totalCursors": "Total des Curseurs",
      "lastSync": "Dernière Synchronisation"
    },
    "cursors": {
      "title": "Curseurs de Synchronisation",
      "viewModes": {
        "cards": "Cartes",
        "table": "Tableau",
        "projects": "Par Projets",
        "list": "Liste"
      },
      "actions": {
        "clear": "Effacer",
        "bulkSync": "Synchronisation en Masse ({count})",
        "bulkReset": "Réinitialisation en Masse ({count})",
        "createCursor": "Créer un Curseur"
      }
    },
    "auto": {
      "managed": "Auto",
      "manual": "Manuel",
      "enableAuto": "Activer Auto ({count})",
      "disableAuto": "Désactiver Auto ({count})",
      "reason": "Raison",
      "reasons": {
        "importedActive": "Formulaire actif importé",
        "createdActive": "Formulaire actif créé",
        "uploadedActive": "Formulaire actif téléversé",
        "formOpened": "Formulaire ouvert",
        "formClosed": "Formulaire fermé",
        "formReopened": "Formulaire rouvert",
        "newFormOpened": "Nouveau formulaire ouvert",
        "migrated": "Migré",
        "formNotFound": "Formulaire non trouvé",
        "manualOverride": "Surcharge manuelle",
        "formDeleted": "Formulaire supprimé",
        "importedFormDeleted": "Formulaire importé supprimé"
      }
    },
    "projectSummary": {
      "forms": "Formulaires: {count}",
      "lastSync": "Dernière Synchronisation",
      "active": "Actifs: {count}",
      "errors": "Erreurs: {count}",
      "inactive": "Inactifs: {count}",
      "noProjects": "Aucun Projet",
      "createFirstCursor": "Créez votre premier curseur de synchronisation"
    },
    "projectResponsible": {
      "responsible": "Responsable",
      "notAssigned": "Non assigné",
      "assign": "Assigner",
      "remove": "Retirer",
      "assignModal": {
        "title": "Assigner un responsable pour le projet \"{project}\"",
        "selectUser": "Sélectionner un utilisateur",
        "selectUserPlaceholder": "Sélectionner la personne responsable",
        "assign": "Assigner",
        "noUsers": "Aucun utilisateur disponible",
        "noUsersMessage": "Il n'y a pas d'utilisateurs dans l'organisation pour assigner comme responsable du projet."
      }
    },
    "modals": {
      "createCursor": {
        "title": "Créer un Curseur de Synchronisation",
        "server": "Serveur",
        "project": "Projet",
        "xmlForm": "Formulaire XML",
        "serverPlaceholder": "Sélectionner le serveur",
        "projectPlaceholder": "Sélectionner le projet",
        "xmlFormPlaceholder": "Sélectionner le formulaire"
      },
      "manualSync": {
        "title": "Synchronisation Manuelle",
        "selectCursors": "Sélectionner les Curseurs",
        "forceFullSync": "Forcer la Synchronisation Complète",
        "maxConcurrent": "Maximum de Synchronisations Concurrentes",
        "startSync": "Démarrer la Synchronisation"
      }
    },
    "messages": {
      "schedulerPaused": "Planificateur de synchronisation ODK mis en pause",
      "schedulerResumed": "Planificateur de synchronisation ODK repris",
      "cursorCreated": "Curseur de synchronisation créé avec succès",
      "manualSyncTriggered": "Synchronisation manuelle déclenchée avec succès",
      "cursorReset": "Curseur réinitialisé avec succès",
      "bulkResetSuccess": "Réinitialisation réussie de {count} curseurs",
      "selectCursorsForSync": "Veuillez sélectionner au moins un curseur pour la synchronisation",
      "never": "Jamais"
    },
    "errors": {
      "failedToLoadSyncData": "Échec du chargement des données de synchronisation",
      "failedToControlScheduler": "Échec du contrôle du planificateur",
      "failedToCreateCursor": "Échec de la création du curseur de synchronisation",
      "failedToTriggerManualSync": "Échec du déclenchement de la synchronisation manuelle",
      "failedToResetCursor": "Échec de la réinitialisation du curseur",
      "failedToResetSomeCursors": "Échec de la réinitialisation de certains curseurs"
    },
    "filters": {
      "showAllForms": "Afficher toutes les formes",
      "filteringTitle": "Filtrage des formes",
      "filteringMessage": "Affichage de {filtered} sur {total} formes. Masquées {hidden} formes avec statut 'fermé', 'inconnu' ou sans statut défini."
    },
    "formStatus": {
      "title": "Statut des formes et optimisation",
      "checkStatuses": "Vérifier les statuts",
      "statusLabels": {
        "open": "Ouvertes",
        "closing": "En fermeture",
        "closed": "Fermées",
        "unknown": "Inconnu"
      },
      "cards": {
        "title": "Statut des formes",
        "description": "Vérifier et optimiser les curseurs",
        "refresh": "Actualiser"
      },
      "loading": "Chargement...",
      "autoCheckInterval": "5 minutes",
      "lastCheck": "Automatiquement toutes les 5 minutes",
      "benefits": {
        "autoDisable": "Désactivation automatique des curseurs pour les formes fermées",
        "resourceOptimization": "Optimisation des ressources de synchronisation",
        "performanceImprovement": "Performance améliorée"
      },
      "messages": {
        "checkStarted": "Vérification du statut des formes démarrée",
        "checkError": "Erreur lors de la vérification des statuts de formes",
        "enableError": "Erreur lors de l'activation des curseurs",
        "disableError": "Erreur lors de la désactivation des curseurs"
      }
    }
  },
  "odkQc": {
    "dashboard": {
      "title": "Tableau de Bord QC - Qualité des Données ODK",
      "description": "Surveillance de la qualité des données des soumissions ODK à l'aide de règles de validation"
    },
    "statistics": {
      "totalRules": "Total des Règles",
      "activeRules": "Règles Actives",
      "inactiveRules": "Règles Inactives",
      "recentValidations": "Validations Récentes"
    },
    "sections": {
      "rulesByType": "Règles par Type",
      "rulesBySeverity": "Règles par Niveau de Sévérité",
      "qcRules": "Règles QC"
    },
    "filters": {
      "allTypes": "Tous les Types",
      "allLevels": "Tous les Niveaux",
      "allStatuses": "Tous les Statuts",
      "active": "Actif",
      "inactive": "Inactif"
    },
    "actions": {
      "createRule": "Créer une Règle",
      "activate": "Activer",
      "deactivate": "Désactiver",
      "clearSelection": "Effacer la Sélection"
    },
    "ruleTypes": {
      "required": "Requis",
      "constraint": "Contrainte",
      "calculation": "Calcul",
      "custom": "Personnalisé"
    },
    "severityLevels": {
      "error": "Erreur",
      "warning": "Avertissement",
      "info": "Information"
    },
    "messages": {
      "noRuleTypeData": "Aucune donnée de type de règle disponible",
      "noSeverityData": "Aucune donnée de sévérité disponible",
      "ruleUpdated": "Règle mise à jour avec succès",
      "ruleCreated": "Règle créée avec succès",
      "ruleSaveError": "Erreur lors de la sauvegarde de la règle",
      "ruleLoadError": "Erreur lors du chargement des données",
      "ruleStatusToggled": "Statut de la règle {ruleName} modifié",
      "ruleStatusError": "Erreur lors du changement de statut de la règle",
      "confirmDeleteRule": "Supprimer la règle \"{ruleName}\"?",
      "ruleDeleted": "Règle supprimée avec succès",
      "ruleDeleteError": "Erreur lors de la suppression de la règle",
      "ruleSaved": "Règle sauvegardée avec succès",
      "bulkStatusToggled": "Statut modifié pour {count} règles",
      "bulkStatusError": "Erreur lors du changement de statut des règles",
      "bulkDeleted": "Supprimées {count} règles",
      "bulkDeleteError": "Erreur lors de la suppression des règles",
      "rulesDeleted": "Règles supprimées",
      "rulesActivated": "Règles activées",
      "rulesDeactivated": "Règles désactivées",
      "ruleNotFound": "Règle non trouvée",
      "invalidJsonFormat": "Format JSON invalide",
      "createExpressionFirst": "Créer l'expression d'abord",
      "previewError": "Erreur lors de l'aperçu",
      "invalidRuleExpression": "Expression de règle invalide",
      "ruleNotExecuted": "Règle non exécutée",
      "loadingRule": "Chargement de la règle...",
      "saving": "Sauvegarde...",
      "loading": "Chargement...",
      "run": "Exécuter",
      "passed": "Réussi",
      "failed": "Échoué",
      "success": "Succès",
      "errorDuringValidation": "Erreur lors de la validation",
      "noQcRulesFound": "Aucune règle QC trouvée"
    },
    "form": {
      "ruleName": "Nom de la Règle",
      "ruleNameRequired": "Le nom de la règle est requis",
      "fieldPath": "Champ Principal",
      "fieldPathRequired": "Le champ principal est requis",
      "fieldPathHint": "Le champ principal que cette règle valide. D'autres champs peuvent être utilisés dans l'expression JSONLogic.",
      "errorMessage": "Message d'Erreur",
      "errorMessageHint": "Affiché aux revues lorsqu'un envoi échoue cette règle.",
      "errorMessageRequired": "Le message d'erreur est requis",
      "constraintExpression": "Expression de Contrainte",
      "constraintExpressionHint": "Utilisez '{'\"var\": \"field_name\"'}' pour référencer les champs de soumission. Cliquez sur Appliquer pour valider JSON.",
      "constraintExpressionRequired": "L'expression de contrainte est requise",
      "ruleType": "Type de Règle",
      "severityLevel": "Niveau de Sévérité",
      "ruleActive": "La règle est active",
      "ruleActiveHint": "Les règles inactives sont conservées mais non appliquées lors de la validation.",
      "basicSettings": "Paramètres de Base",
      "jsonLogicBuilder": "Constructeur JSONLogic",
      "jsonLogicBuilderHint": "Définit quand cette règle passe. L'expression doit évaluer à vrai pour les envois valides.",
      "reset": "Réinitialiser",
      "apply": "Appliquer",
      "saveChanges": "Sauvegarder les Modifications",
      "createRule": "Créer une Règle",
      "editRule": "Modifier la Règle",
      "rulePreview": "Aperçu de la Règle",
      "testRuleOnSample": "Tester la règle sur des données d'exemple",
      "detailedResults": "Résultats Détaillés",
      "showSubmissionData": "Afficher les données de soumission",
      "help": "Aide",
      "ruleTypes": "Types de Règle",
      "severityLevels": "Niveaux de Sévérité",
      "requiredField": "Champ requis",
      "constraintCheck": "Vérification de contrainte",
      "calculatedField": "Champ calculé",
      "customLogic": "Logique personnalisée",
      "blocksSubmission": "Bloque la soumission",
      "showsWarning": "Affiche un avertissement",
      "informationalMessage": "Message informatif",
      "jsonLogicExamplesTitle": "Exemples d'expressions JSONLogic pour hh_question:",
      "agreementCheckExample": "Vérification d'accord:",
      "finalStatusCheckExample": "Vérification du statut final:",
      "enumeratorCheckExample": "Vérification de l'énumérateur:",
      "complexLogicExample": "Logique complexe:",
      "fieldValue": "Valeur du champ",
      "previewStatsLine": "{passed} approuvés · {failed} échoués · {rate}%"
    },
    "placeholders": {
      "searchByNameFieldMessage": "Rechercher par nom, champ ou message...",
      "ruleType": "Type de règle",
      "severityLevel": "Niveau de sévérité",
      "status": "Statut",
      "enterRuleName": "Entrer le nom de la règle",
      "enterErrorMessage": "Entrer le message d'erreur",
      "respondentAge": "respondent.age"
    },
    "table": {
      "ariaLabels": {
        "disableRule": "Désactiver la règle",
        "enableRule": "Activer la règle"
      }
    },
    "viewModes": {
      "cards": "Cartes",
      "table": "Tableau"
    }
  },
  "odkCleanup": {
    "page": {
      "title": "Moniteur de nettoyage des données ODK",
      "subtitle": "Surveiller le système de nettoyage automatique et afficher les statistiques",
      "selectFormTitle": "Sélectionner un formulaire pour la surveillance du nettoyage",
      "currentProject": "Projet actuel",
      "searchPlaceholder": "Rechercher et sélectionner un formulaire...",
      "systemInfo": {
        "title": "Système de nettoyage automatique",
        "activeFormsTitle": "Formulaires actifs (ouverts/fermeture)",
        "activeFormsDesc": "Seuls les 5 dossiers les plus récents sont automatiquement conservés. Le nettoyage a lieu lors de chaque synchronisation.",
        "closedFormsTitle": "Formulaires fermés (fermés)",
        "closedFormsDesc": "Lorsqu'un formulaire est fermé, 4 dossiers sont automatiquement archivés, en laissant 1 pour les statistiques.",
        "monitoringTitle": "Surveillance",
        "monitoringDesc": "Sélectionnez un formulaire ci-dessus pour afficher les statistiques et surveiller le système."
      }
    },
    "manager": {
      "title": "Gestionnaire de nettoyage des données ODK",
      "loading": "Chargement des données de nettoyage...",
      "noData": {
        "title": "Aucune donnée disponible",
        "meaning": "Ce que cela signifie :",
        "noSubmissions": "Ce formulaire n'a pas encore de soumissions",
        "noSync": "Le formulaire n'a pas été synchronisé depuis ODK Central",
        "noCleanupNeeded": "Aucun nettoyage n'est nécessaire pour le moment"
      },
      "errorLoading": "Erreur lors du chargement des données",
      "stats": {
        "title": "Statistiques actuelles",
        "totalFolders": "Total des dossiers",
        "totalSize": "Taille totale",
        "completeData": "Données complètes"
      },
      "formInfo": {
        "title": "Informations sur le formulaire",
        "state": "État :",
        "active": "Actif :",
        "lastSubmission": "Dernière soumission :",
        "lastSync": "Dernière synchro :",
        "yes": "Oui",
        "no": "Non"
      },
      "recommendation": {
        "title": "Recommandation de nettoyage",
        "action": "Action :",
        "reason": "Raison :",
        "requiresApproval": "Nécessite une approbation pour le nettoyage"
      },
      "buttons": {
        "refresh": "Actualiser les stats",
        "dryRun": "Test à blanc",
        "cleanupNow": "Nettoyer maintenant",
        "forceCleanup": "Forcer le nettoyage"
      },
      "results": {
        "title": "Résultat du dernier nettoyage",
        "strategy": "Stratégie :",
        "kept": "Conservé : {count} dossiers",
        "deleted": "Supprimé : {count} dossiers",
        "archived": "Archivé : {count} dossiers",
        "skipped": "Ignoré : {count} dossiers"
      },
      "folders": {
        "title": "Dossiers récents ({count})",
        "columns": {
          "name": "Nom du dossier",
          "created": "Créé",
          "size": "Taille (MB)",
          "files": "Fichiers"
        }
      }
    },
    "messages": {
      "globalCleanupSuccess": "Nettoyage global terminé avec succès",
      "globalCleanupFailed": "Le nettoyage global a échoué",
      "errorLoadingProjects": "Erreur lors du chargement des projets",
      "errorLoadingForms": "Erreur lors du chargement des formulaires",
      "noDataOrSync": "Ce formulaire n'a pas de données ou n'a pas encore été synchronisé",
      "statsLoadFailed": "Échec du chargement des statistiques de nettoyage",
      "dryRunSuccess": "Test à blanc terminé - aucun fichier n'a été supprimé",
      "dryRunFailed": "Le test à blanc a échoué",
      "cleanupNotRecommended": "Nettoyage non recommandé pour ce formulaire",
      "cleanupSuccess": "Nettoyage terminé avec succès",
      "cleanupFailed": "Le nettoyage a échoué",
      "forceNotAvailable": "Nettoyage forcé non disponible pour ce formulaire",
      "forceConfirm": "Êtes-vous sûr de vouloir forcer le nettoyage ? Cette action est irréversible.",
      "forceSuccess": "Nettoyage forcé terminé avec succès",
      "forceFailed": "Le nettoyage forcé a échoué"
    }
  },
  "permissionGroups": {
    "create": "Créer un groupe",
    "delete": "Supprimer le groupe",
    "assignToUser": "Assigner le groupe à l'utilisateur",
    "removeFromUser": "Retirer le groupe de l'utilisateur",
    "roleNames": {
      "manager": "Gestionnaire",
      "projectMember": "Membre du projet",
      "dataViewer": "Visualiseur de données",
      "dataCollector": "Collecteur de données",
      "dataDownloader": "Téléchargeur de données",
      "dataAnalyst": "Analyste de données",
      "qcViewer": "Visualiseur de QC",
      "qcEditor": "Éditeur de QC",
      "monitor": "Moniteur",
      "formDesigner": "Concepteur de formulaires"
    },
    "userManagement": {
      "clientGroups": "Groupes de clients",
      "clientGroupsDescription": "Groupes destinés aux utilisateurs externes ou côté client.",
      "regularGroups": "Groupes réguliers",
      "regularGroupsDescription": "Groupes destinés aux membres internes du projet.",
      "errorTitle": "Impossible de charger les groupes",
      "noProjectsTitle": "Sélectionnez d'abord un projet",
      "noProjectsDescription": "Choisissez un projet avant d'attribuer des groupes de permissions.",
      "noGroupsTitle": "Aucun groupe disponible",
      "noGroupsAvailable": "Aucun groupe disponible pour l'assignation",
      "errorLoadingGroups": "Erreur lors du chargement des groupes",
      "selectedGroups": "Groupes sélectionnés",
      "selectedCount": "{count} sélectionnés",
      "selectedPill": "Sélectionné",
      "includedPermissions": "Permissions incluses",
      "groupDetailsTitle": "Détails du groupe",
      "groupDescriptionFallback": "Aucune description fournie.",
      "rolesCount": "Rôles : {count}",
      "viewGroupDetails": "Voir les rôles dans {name}"
    }
  },
  "menu": {
    "dashboard": "Tableau de bord",
    "my-organization": "Mon organisation",
    "userManagement": "Gestion des utilisateurs",
    "organizationStats": "Statistiques de l'organisation",
    "organizationSettings": "Paramètres de l'organisation",
    "projects": "Projets",
    "odkServers": "Serveurs ODK",
    "odkSync": "Synchronisation ODK",
    "payments": "Paiements",
    "faq": "Aide",
    "preferences": "Préférences du compte",
    "settings": "Paramètres de l'application",
    "billing": "Facturation",
    "help": "Aide"
  },
  "organization": {
    "settingsSubtitle": "Gérez le profil de l'organisation, l'abonnement IA, les cartes et l'infrastructure connectée.",
    "profile": {
      "sectionTitle": "Profil de l'organisation",
      "name": "Nom",
      "description": "Description",
      "edit": "Modifier",
      "editTitle": "Modifier l'organisation",
      "noDescription": "Aucune description",
      "created": "Créée",
      "updated": "Mise à jour",
      "loadError": "Impossible de charger le profil de l'organisation"
    },
    "infrastructure": {
      "sectionTitle": "Infrastructure connectée",
      "subtitle": "Résumé des serveurs, projets, utilisateurs et formulaires actifs.",
      "servers": "Serveurs ODK",
      "projects": "Projets",
      "users": "Utilisateurs",
      "activeForms": "Formulaires actifs",
      "defaultServer": "Serveur ODK par défaut",
      "noDefaultServer": "Aucun serveur par défaut",
      "manageServers": "Gérer les serveurs ODK",
      "viewSync": "Ouvrir Sync Workbench",
      "loadError": "Impossible de charger le résumé d'infrastructure"
    },
    "quickLinks": {
      "sectionTitle": "Pages associées",
      "userManagement": "Gestion des utilisateurs",
      "statistics": "Statistiques de l'organisation",
      "projects": "Projets",
      "reportTemplates": "Modèles de rapports",
      "odkServers": "Serveurs ODK",
      "syncWorkbench": "Synchro"
    }
  },
  "preferences": {
    "title": "Préférences",
    "subtitle": "Revisez votre profil de compte, accès à l'organisation, groupes de permissions et rôles de projet.",
    "accessOverview": "Aperçu des accès",
    "organizationOwner": "Propriétaire de l'organisation",
    "organizationOwnerDescription": "Vous avez un accès complet à toutes les ressources et projets de l'organisation.",
    "permissionGroups": "Groupes de permissions",
    "permissionGroupsDescription": "Groupes par projet et leurs rôles",
    "perProject": "Par projet",
    "noProjectGroups": "Aucun groupe spécifique au projet.",
    "projectsAccess": "Accès aux projets",
    "projectsAccessDescription": "Projets que vous pouvez ouvrir et vos rôles",
    "ownerNoProjects": "En tant que propriétaire de l'organisation, vous avez un accès complet. Les projets apparaîtront une fois créés ou importés.",
    "noProjectAccess": "Aucun accès aux projets pour le moment.",
    "projectIdLabel": "ID : {id}",
    "projectLabelFallback": "Projet #{id}",
    "memberSince": "Membre depuis :",
    "userFallback": "Utilisateur",
    "invalidDate": "Date invalide",
    "name": "Nom",
    "email": "E-mail",
    "password": "Mot de passe",
    "resetPassword": "Réinitialiser le mot de passe",
    "emailSubscriptions": "Abonnements e-mail",
    "emailSubscriptionsVisit": "Pour gérer les e-mails que vous recevez, visitez les",
    "notificationSettingsLink": "Paramètres de notification",
    "cancelAccount": "Supprimer le compte",
    "cancelAccountDescription": "Supprimer définitivement votre organisation, les utilisateurs et toutes les données associées.",
    "cancelAccountAction": "Supprimer le compte",
    "editName": "Modifier le nom",
    "editNameSubtitle": "Mettez à jour le nom affiché dans l'application.",
    "nameRequired": "Le nom est obligatoire",
    "nameMinLength": "Le nom doit contenir au moins 2 caractères",
    "nameUpdateFailed": "Échec de la mise à jour du nom. Veuillez réessayer.",
    "nameChangedSuccess": "Votre nom a été modifié avec succès",
    "resetPasswordTitle": "Réinitialiser le mot de passe",
    "resetPasswordSubtitle": "Saisissez votre mot de passe actuel, puis choisissez-en un nouveau.",
    "passwordRequirementsTitle": "Exigences du mot de passe",
    "currentPassword": "Mot de passe actuel",
    "newPassword": "Nouveau mot de passe",
    "repeatNewPassword": "Répéter le nouveau mot de passe",
    "passwordMinLength": "Doit contenir au moins 8 caractères",
    "passwordUniqueChars": "Doit contenir au moins 6 caractères différents",
    "updatePassword": "Mettre à jour le mot de passe",
    "passwordChangedSuccess": "Votre mot de passe a été modifié avec succès",
    "passwordUpdateFailed": "Échec de la mise à jour du mot de passe. Veuillez réessayer.",
    "currentPasswordRequired": "Le champ mot de passe actuel est obligatoire",
    "newPasswordRequired": "Le champ nouveau mot de passe est obligatoire",
    "repeatPasswordRequired": "Le champ répéter le mot de passe est obligatoire",
    "passwordMatchUnique": "Le nouveau mot de passe ne peut pas être identique à l'actuel",
    "confirmPasswordMismatch": "La confirmation ne correspond pas au nouveau mot de passe",
    "dangerZoneTitle": "Zone de danger",
    "dangerZoneSubtitle": "Actions irréversibles qui affectent toute votre organisation.",
    "cancelAccountModalTitle": "Supprimer le compte",
    "cancelAccountModalSubtitle": "Vérifiez votre identité et confirmez que vous souhaitez supprimer définitivement votre compte.",
    "cancelAccountConsequenceOrg": "Votre organisation et tous les projets seront supprimés",
    "cancelAccountConsequenceUsers": "Tous les membres de l'organisation perdront l'accès",
    "cancelAccountConsequenceOdk": "Les données ODK liées peuvent être supprimées définitivement",
    "cancelAccountConsequenceIrreversible": "Cette action est irréversible",
    "cancelAccountConfirmEmailLabel": "Saisissez votre adresse e-mail pour confirmer",
    "cancelAccountConfirmEmailRequired": "La confirmation de l'e-mail est obligatoire",
    "cancelAccountConfirmEmailMismatch": "L'e-mail ne correspond pas à votre compte",
    "cancelAccountAcknowledge": "Je comprends que cela supprimera définitivement mon organisation et toutes les données associées",
    "cancelAccountAcknowledgeRequired": "Vous devez confirmer que vous comprenez les conséquences",
    "cancelAccountDeleteButton": "Supprimer le compte définitivement",
    "cancelAccountUnavailableTitle": "La suppression du compte n'est pas encore disponible",
    "cancelAccountUnavailableMessage": "Votre identité a été vérifiée. La suppression du compte est en préparation — contactez votre administrateur ou le support pour demander la fermeture du compte.",
    "cancelAccountWrongPassword": "Mot de passe incorrect. Veuillez réessayer.",
    "dangerZoneCancelAccount": "Zone de danger : Supprimer le compte",
    "cancelAccountWarning": "Cela supprimera définitivement votre compte et toutes les données associées, y compris votre organisation, les utilisateurs et les données ODK liées.",
    "groupFallback": "Groupe"
  },
  "faq": {
    "title": "Aide",
    "subtitle": "Guides courts et réponses pour les tâches courantes dans UDACAPI."
  },
  "settings": {
    "title": "Paramètres",
    "subtitle": "Ajustez l'apparence de l'application, la langue et les préférences de notification.",
    "themeSection": "Thème",
    "generalSection": "Préférences générales",
    "notificationsNoticeTitle": "Vos paramètres de notification sont regroupés et simplifiés",
    "notificationsNoticeBody": "Vos choix de paramètres précédents ne sont pas modifiés."
  },
  "projects": {
    "pageTitle": "Projets",
    "subtitle": "Gérez vos projets, changez entre cartes et tableaux, et lancez des flux d'importation ou de création.",
    "refresh": "Actualiser",
    "createProject": "Créer un Projet",
    "importRestrictions": {
      "message": "L'importation de projets est autorisée uniquement sur les serveurs appartenant à l'organisation. Les serveurs Partagés et Globaux ne peuvent pas être utilisés pour importer des projets."
    },
    "viewMode": {
      "cards": "Cartes",
      "table": "Tableau"
    },
    "sections": {
      "forms": {
        "title": "Formulaires du projet"
      },
      "users": {
        "title": "Utilisateurs du projet"
      },
      "formAccess": {
        "title": "Accès aux formulaires",
        "description": "Choisissez quels App Users peuvent télécharger chaque formulaire dans ODK Collect.",
        "save": "Enregistrer",
        "discard": "Annuler",
        "saving": "Enregistrement…",
        "saved": "Accès aux formulaires enregistré",
        "saveError": "Impossible d’enregistrer toutes les modifications",
        "loadError": "Impossible de charger l’accès aux formulaires",
        "emptyForms": "Aucun formulaire publié dans ce projet",
        "emptyAppUsers": "Pas encore d’App Users. Créez d’abord un code QR.",
        "openQr": "Ouvrir le QR workbench",
        "openForms": "Ouvrir les formulaires",
        "dirtyHint": "Modifications non enregistrées"
      },
      "info": {
        "title": "Informations du projet",
        "basicInfo": "Informations de base",
        "accessInfo": "Accès",
        "statistics": "Statistiques du projet",
        "fields": {
          "projectId": "ID du projet",
          "name": "Nom",
          "description": "Description",
          "status": "Statut",
          "orgId": "ID de l'organisation",
          "odkProjectId": "ID projet ODK",
          "createdAt": "Date de création",
          "updatedAt": "Dernière mise à jour",
          "yourRole": "Votre rôle",
          "canManageForms": "Peut gérer les formulaires",
          "canViewUsers": "Peut voir les utilisateurs",
          "isManager": "Est manager",
          "isOwner": "Est propriétaire",
          "totalUsers": "Utilisateurs du projet"
        },
        "status": {
          "active": "Actif",
          "archived": "Archivé"
        },
        "noDescription": "Aucune description",
        "loading": "Chargement des informations du projet...",
        "loadError": "Échec du chargement des informations du projet",
        "statsLoadError": "Échec du chargement des statistiques du projet",
        "invalidDate": "Date invalide",
        "notAvailable": "N/D"
      }
    },
    "users": {
      "dialog": {
        "addTitle": "Ajouter un utilisateur au projet",
        "editTitle": "Modifier l'accès au projet",
        "addSubtitle": "Sélectionnez d'abord un utilisateur, puis attribuez des groupes de permissions pour ce projet.",
        "editSubtitle": "Vérifiez l'utilisateur sélectionné et mettez à jour les groupes de permissions pour ce projet.",
        "stepOne": "Étape 1",
        "stepTwo": "Étape 2",
        "stepReady": "Prêt",
        "stepRequired": "Obligatoire",
        "stepLocked": "Verrouillé",
        "selectUserTitle": "Sélectionner un utilisateur",
        "selectedUser": "Utilisateur sélectionné",
        "selectUserHint": "Choisissez qui doit recevoir l'accès à ce projet.",
        "selectedUserHint": "Cet utilisateur est déjà affecté au projet. Vous pouvez mettre à jour ses groupes de permissions ci-dessous.",
        "selectUserPlaceholder": "Sélectionnez un utilisateur",
        "selectUserHelper": "Les propriétaires et les superutilisateurs n'apparaissent pas dans cette liste.",
        "permissionGroupsTitle": "Groupes de permissions",
        "permissionGroupsHint": "Sélectionnez un ou plusieurs groupes de permissions pour l'utilisateur choisi.",
        "permissionGroupsLockedTitle": "Sélectionnez un utilisateur pour continuer",
        "permissionGroupsLockedHint": "Les groupes de permissions seront disponibles après avoir choisi un utilisateur.",
        "addToProject": "Ajouter au projet",
        "clientUser": "Utilisateur client",
        "internalUser": "Utilisateur interne"
      },
      "dialogs": {
        "removeUser": {
          "title": "Retirer l'utilisateur du projet",
          "message": "Voulez-vous vraiment retirer cet utilisateur du projet ?",
          "confirm": "Retirer"
        }
      },
      "list": {
        "searchPlaceholder": "Rechercher des utilisateurs",
        "filterByPermissionGroups": "Filtrer par groupes de permissions",
        "accessDeniedTitle": "Accès refusé",
        "accessDeniedMessage": "Vous n'avez pas l'autorisation de voir les utilisateurs de ce projet.",
        "loadErrorTitle": "Impossible de charger les utilisateurs du projet",
        "emptyTitle": "Aucun utilisateur dans le projet pour le moment",
        "emptyMessage": "Ajoutez le premier utilisateur pour commencer à gérer l'accès au projet.",
        "emptyFilteredTitle": "Aucun utilisateur ne correspond aux filtres actuels",
        "emptyFilteredMessage": "Essayez de modifier la recherche ou les groupes de permissions sélectionnés.",
        "noPermissionGroups": "Aucun groupe de permissions"
      },
      "messages": {
        "saveSuccess": "L'accès de l'utilisateur a été mis à jour avec succès.",
        "removeSuccess": "L'utilisateur a été retiré du projet."
      },
      "errors": {
        "assignGroupsFailed": "Échec de l'attribution des groupes de permissions. Veuillez réessayer.",
        "assignRoleFailed": "Impossible d'attribuer le rôle du projet.",
        "loadUsersFailed": "Impossible de charger les utilisateurs du projet.",
        "permissionGroupsLoadFailed": "Impossible de charger les groupes de permissions.",
        "projectMemberRoleFailed": "Impossible de résoudre le rôle project member.",
        "removeUserFailed": "Impossible de retirer l'utilisateur du projet.",
        "rolesLoadFailed": "Impossible de charger les rôles du projet.",
        "saveUserFailed": "Impossible de mettre à jour l'accès au projet."
      }
    },
    "modal": {
      "addProject": "Ajouter un projet",
      "editProject": "Modifier le projet",
      "unsavedChanges": "Le formulaire contient des modifications non enregistrées. Êtes-vous sûr de vouloir le fermer ?"
    },
    "form": {
      "projectName": {
        "label": "Nom du Projet",
        "placeholder": "Entrez le nom du projet",
        "required": "Le nom du projet est requis"
      },
      "odkServer": {
        "label": "Serveur ODK",
        "placeholder": "Sélectionner le serveur ODK",
        "required": "Le serveur ODK est requis",
        "noServers": "Aucun serveur ODK disponible. Veuillez d'abord ajouter un serveur."
      },
      "description": {
        "label": "Description",
        "placeholder": "Description optionnelle du projet"
      },
      "buttons": {
        "cancel": "Annuler"
      }
    },
    "cards": {
      "noProjects": "Aucun projet",
      "status": {
        "active": "Actif",
        "archived": "Archivé"
      }
    },
    "confirmations": {
      "odkServerRequired": "Veuillez ajouter au moins un serveur ODK avant de créer un projet.",
      "delete": {
        "imported": {
          "title": "Supprimer le projet importé",
          "message": "Êtes-vous sûr de vouloir supprimer le projet \"{name}\" ?\n\nCe projet a été importé depuis ODK Central. Il ne sera supprimé que de la base de données de cette application, mais restera sur le serveur ODK Central.",
          "messageWithStats": "Êtes-vous sûr de vouloir supprimer le projet \"{name}\" ?\n\nCe projet contient {formsCount} formulaires et {submissionsCount} soumissions.\nLe projet sera archivé/masqué (soft-delete), et les données seront conservées.\n\nCe projet a été importé depuis ODK Central. Il ne sera supprimé que de la base de données de cette application, mais restera sur le serveur ODK Central."
        },
        "regular": {
          "title": "Supprimer le projet",
          "message": "Êtes-vous sûr de vouloir supprimer le projet \"{name}\" ?\n\nAVERTISSEMENT : Cela supprimera définitivement le projet de la base de données de cette application et du serveur ODK Central.",
          "messageWithStats": "Êtes-vous sûr de vouloir supprimer le projet \"{name}\" ?\n\nCe projet contient {formsCount} formulaires et {submissionsCount} soumissions.\nLe projet sera archivé/masqué (soft-delete), et les données seront conservées."
        },
        "confirmButton": "Supprimer"
      }
    },
    "notifications": {
      "organizationNotSelected": "Organisation non sélectionnée"
    },
    "import": {
      "title": "Importer des Projets ODK",
      "subtitle": "Chargez des projets ODK existants du serveur de l'organisation et importez-les dans cet espace de travail.",
      "selectServer": "Sélectionner le Serveur ODK",
      "getProjects": "Obtenir les Projets",
      "availableProjects": "Projets Disponibles",
      "noProjectsFound": "Aucun projet trouvé sur le serveur sélectionné.",
      "importProject": "Importer",
      "imported": "Importé",
      "errors": {
        "serversLoadFailed": "Impossible de charger les serveurs ODK. Veuillez réessayer plus tard.",
        "projectsLoadFailed": "Impossible de charger les projets du serveur ODK. Veuillez vérifier la connexion et réessayer.",
        "importFailed": "Impossible d'importer le projet. Veuillez réessayer plus tard.",
        "importError": "Erreur lors de l'importation du projet : {detail}"
      }
    },
    "importForms": {
      "title": "Importer des Formulaires ODK",
      "subtitle": "Sélectionnez des formulaires de votre projet ODK Central pour les ajouter ici.",
      "subtitleWithProject": "Sélectionnez des formulaires du projet Central {odkProjectId} pour les ajouter à {name}.",
      "loadingForms": "Chargement des formulaires du serveur ODK...",
      "availableForms": "Formulaires Disponibles",
      "searchForms": "Rechercher des formulaires...",
      "selectAll": "Tout Sélectionner",
      "deselectAll": "Tout Désélectionner",
      "importSelected": "Importer les Sélectionnés",
      "noFormsFound": "Aucun formulaire trouvé pour ce projet sur le serveur ODK.",
      "errors": {
        "projectNotLinked": "Le projet n'est pas lié à un serveur ODK",
        "formsLoadFailed": "Impossible de charger les formulaires du serveur ODK. Veuillez réessayer plus tard.",
        "formsLoadError": "Erreur lors du chargement des formulaires : {detail}",
        "importFailed": "Impossible d'importer les formulaires. Veuillez réessayer plus tard.",
        "importError": "Erreur d'importation : {detail}"
      },
      "status": {
        "imported": "Importé",
        "available": "Disponible"
      },
      "progress": {
        "started": "Importation démarrée",
        "completedSummary": "Les formulaires sont prêts dans ce projet.",
        "failedSummary": "Certains formulaires n'ont pas pu être importés. Consultez les détails ci-dessous.",
        "viewProject": "Voir le projet",
        "forms": "{done} / {total} formulaires",
        "submissions": "{count} soumissions traitées",
        "submissionsProgress": "{fetched} / {total} soumissions synchronisées",
        "stages": {
          "queued": "En attente de démarrage",
          "pending": "En attente de démarrage",
          "importingForms": "Import des formulaires",
          "syncingData": "Synchronisation des données"
        },
        "messages": {
          "queued": "La tâche est en file d'attente, en attente de démarrage...",
          "importingForms": "Import des métadonnées des formulaires..."
        }
      }
    },
    "detail": {
      "loading": "Chargement du projet...",
      "returnToProjects": "Retour aux projets",
      "forms": {
        "title": "Formulaires du projet",
        "noForms": "Le projet n'a pas de formulaires.",
        "contactAdmin": "Contactez l'administrateur pour ajouter des formulaires.",
        "actions": {
          "publish": "Publier",
          "abandon": "Abandonner",
          "attachments": "Pièces jointes",
          "qrCode": "Code QR pour les tests",
          "previewEnketo": "Aperçu dans Enketo",
          "downloadTestData": "Télécharger les données de test",
          "formSettings": "Paramètres du formulaire",
          "viewDetails": "Voir/Détails",
          "changeState": "Changer l'état",
          "delete": "Supprimer/Abandonner"
        },
        "modals": {
          "qrCode": {
            "title": "Code QR pour les tests",
            "description": "Scannez le code QR pour tester le formulaire"
          },
          "formSettings": {
            "title": "Paramètres du formulaire",
            "basicSettings": "Paramètres de base (Placeholder)",
            "accessSettings": "Paramètres d'accès (Placeholder)",
            "placeholder": "Ceci est une interface de démonstration. La fonctionnalité est en développement."
          }
        },
        "messages": {
          "tryAgain": "Réessayer",
          "publishing": "Publication du formulaire {name}...",
          "published": "Formulaire {name} publié avec succès",
          "previewing": "Aperçu de {name} dans Enketo (dev placeholder)",
          "downloading": "Téléchargement des données de test pour {name} (dev placeholder)",
          "saving": "Sauvegarde des paramètres pour {name} (dev placeholder)",
          "missingData": "Données manquantes pour importer les formulaires",
          "missingXlsformData": "Données manquantes pour charger le XLSForm",
          "noAttachments": "Le formulaire n'a pas de pièces jointes"
        }
      }
    },
    "qc": {
      "rules": {
        "ruleTypes": {
          "required": "Required field",
          "constraint": "Constraint",
          "calculation": "Calculation",
          "custom": "Custom"
        },
        "severity": {
          "error": "Error",
          "warning": "Warning",
          "info": "Info"
        },
        "form": {
          "tabs": {
            "basic": "Basic settings",
            "preview": "Preview"
          },
          "ruleNameLabel": "Rule name *",
          "ruleNamePlaceholder": "Enter rule name",
          "ruleTypeLabel": "Rule type *",
          "severityLabel": "Severity level *",
          "fieldPathLabel": "Field path *",
          "fieldPathPlaceholder": "respondent.age",
          "constraintExpressionLabel": "Constraint expression *",
          "calculationFormulaLabel": "Calculation formula *",
          "simpleEditor": "Simple editor",
          "jsonLogicBuilder": "JSONLogic Builder",
          "applyJsonLogic": "Apply JSONLogic",
          "errorMessageLabel": "Error message *",
          "errorMessagePlaceholder": "Enter error message",
          "activeLabel": "Rule active",
          "previewTitle": "Rule Preview",
          "runPreview": "Run Preview",
          "previewHint": "Tests rule on sample data",
          "invalidJson": "Invalid JSON format",
          "createExpressionFirst": "Create rule expression first",
          "previewError": "Error executing preview",
          "previewResults": "Preview results ({count} records):",
          "passed": "Passed:",
          "failed": "Failed:",
          "successRate": "Success rate:",
          "validation": {
            "ruleNameRequired": "Rule name is required",
            "fieldPathRequired": "Field path is required",
            "errorMessageRequired": "Error message is required",
            "constraintExpressionRequired": "Constraint expression is required",
            "calculationFormulaRequired": "Calculation formula is required"
          },
          "toasts": {
            "ruleCreated": "Rule created successfully",
            "ruleUpdated": "Rule updated successfully",
            "saveError": "Error saving rule"
          }
        }
      }
    }
  },
  "odkServers": {
    "title": "Serveurs ODK",
    "subtitle": "Gérez les serveurs ODK de l'organisation, leurs configurations, visibilité et état de connexion.",
    "addServer": "Ajouter un serveur",
    "editServer": "Modifier le serveur",
    "deleteServer": "Supprimer le serveur",
    "modal": {
      "addSubtitle": "Connectez un serveur ODK Central à cette organisation.",
      "editSubtitle": "Mettez à jour les paramètres de connexion du serveur."
    },
    "table": {
      "default": "Par défaut",
      "visibility": "Visibilité",
      "setAsDefault": "Définir par défaut",
      "setAsDefaultTooltip": "Définir comme serveur par défaut pour cette organisation",
      "testConnection": "Tester la connexion",
      "testConnectionTooltip": "Tester la connexion au serveur ODK Central",
      "testConnectionDisabled": "Le test de connexion est disponible uniquement pour les serveurs appartenant à l'organisation",
      "editServer": "Modifier le serveur",
      "editServerTooltip": "Modifier les détails du serveur (uniquement pour les serveurs ORGANISATION et avec permissions)",
      "deleteServer": "Supprimer le serveur",
      "deleteServerTooltip": "Supprimer le serveur (uniquement pour les serveurs ORGANISATION et avec permissions)",
      "odkSession": "Session ODK"
    },
    "session": {
      "banner": "Un ou plusieurs serveurs ont une session ODK Central qui expire ou est invalide, ou aucun mot de passe enregistré. Modifiez le serveur et enregistrez le mot de passe pour que l'application puisse se reconnecter automatiquement.",
      "ok": "Session OK",
      "expiresSoon": "Expire bientôt",
      "expired": "Expirée",
      "unknown": "Inconnu",
      "noStoredPassword": "Mot de passe non enregistré"
    },
    "form": {
      "serverName": "Nom du serveur",
      "serverUrl": "URL du serveur",
      "serverUrlPlaceholder": "https://your-odk-central.com",
      "username": "Nom d'utilisateur",
      "password": "Mot de passe",
      "passwordPlaceholderEdit": "Laisser vide pour ne pas changer",
      "description": "Description",
      "serverIsActive": "Serveur actif",
      "serverIsActiveHint": "Les serveurs inactifs restent dans la liste mais ne sont pas proposés lors de la création de projets."
    },
    "validation": {
      "serverNameRequired": "Le nom du serveur est obligatoire",
      "serverUrlRequired": "L'URL du serveur est obligatoire",
      "urlFormatInvalid": "L'URL doit commencer par http:// ou https://",
      "usernameRequired": "Le nom d'utilisateur est obligatoire",
      "passwordRequired": "Le mot de passe est obligatoire"
    },
    "messages": {
      "selectOrganizationFirst": "Veuillez d'abord sélectionner ou créer une organisation",
      "loadingServers": "Chargement des serveurs...",
      "noServersFound": "Aucun serveur ODK trouvé pour cette organisation",
      "failedToLoadServers": "Échec du chargement des serveurs",
      "noServers": "Aucun serveur ODK",
      "serverSaved": "Serveur \"{name}\" {action} avec succès !",
      "serverSetAsDefault": "Serveur \"{name}\" défini par défaut",
      "connectionTestSuccess": "Connexion OK. Projets trouvés : {count}",
      "connectionTestFailed": "Le test de connexion a échoué"
    },
    "contextHint": "Connectez votre serveur ODK avant de synchroniser ou d'importer des formulaires."
  },
  "notifications": {
    "all": "Voir toutes les notifications",
    "less": "Voir moins de notifications"
  },
  "language": {
    "label": "Langue",
    "english": "Anglais",
    "spanish": "Espagnol",
    "french": "Français",
    "swahili": "Swahili",
    "portuguese": "Portugais",
    "ukrainian": "Ukrainien",
    "russian": "Russe",
    "turkish": "Turc"
  },
  "auth": {
    "createAccount": "Créer un compte",
    "dontHaveAccount": "Vous n'avez pas de compte ?",
    "email": "Email",
    "emailInvalid": "L'email doit être valide",
    "emailRequired": "Le champ email est obligatoire",
    "enterEmail": "Saisissez votre email",
    "enterVerificationCode": "Veuillez saisir le code de vérification",
    "forgotPassword": "Mot de passe oublié ?",
    "forgotPasswordDescription": "Si vous avez oublié votre mot de passe, ne vous inquiétez pas. Saisissez simplement votre adresse email ci-dessous, et nous vous enverrons un email avec les instructions pour réinitialiser votre mot de passe. Restaurer l'accès à votre compte n'a jamais été aussi facile.",
    "fullName": "Nom complet",
    "fullNameRequired": "Le champ nom complet est obligatoire",
    "goBack": "Retour",
    "haveAccount": "Vous avez déjà un compte ?",
    "login": "Connexion",
    "password": "Mot de passe",
    "passwordMustContainLetter": "Le mot de passe doit contenir au moins une lettre",
    "passwordMustContainNumber": "Le mot de passe doit contenir au moins un chiffre",
    "passwordMustContainSpecial": "Le mot de passe doit contenir au moins un caractère spécial",
    "passwordMustBe8Chars": "Le mot de passe doit contenir au moins 8 caractères",
    "passwordRequired": "Le champ mot de passe est obligatoire",
    "passwordRequirements": "Le mot de passe doit contenir 8+ caractères : lettres, chiffres et caractères spéciaux.",
    "passwordsDontMatch": "Les mots de passe ne correspondent pas",
    "registrationFailed": "L'inscription a échoué. Veuillez réessayer.",
    "registrationSuccess": "Vous vous êtes inscrit avec succès ! Veuillez vérifier votre email pour les instructions d'activation.",
    "repeatPassword": "Répéter le mot de passe",
    "repeatPasswordRequired": "Le champ répéter le mot de passe est obligatoire",
    "resetInstructionsSent": "Les instructions de réinitialisation du mot de passe ont été envoyées à votre email.",
    "resetInstructionsFailed": "Impossible d'envoyer l'email de réinitialisation du mot de passe. Veuillez réessayer.",
    "resetPassword": "Réinitialiser le mot de passe",
    "sendResetInstructions": "Envoyer les instructions de réinitialisation",
    "signUp": "S'inscrire",
    "twoFactorAuthentication": "Authentification à deux facteurs",
    "verificationCode": "Code de vérification",
    "verificationCodeRequired": "Le code de vérification est obligatoire",
    "verifyCode": "Vérifier le code"
  },
  "dashboard": {
    "subtitle": "Page d'accueil avec visualisations statistiques et informations importantes.",
    "activeFormsTitle": "Formulaires Actifs",
    "activeFormsSubtitle": "Nombre et état des formulaires actifs.",
    "noActiveForms": "Aucun formulaire actif"
  },
  "qr": {
    "title": "Code QR (paramètres ODK Collect)",
    "titleShort": "Code QR",
    "qrName": "Nom du code QR",
    "projectSection": "Projet",
    "projectName": "Nom du projet",
    "projectIcon": "Icône du projet",
    "projectColor": "Couleur du projet",
    "generalSection": "Paramètres généraux",
    "serverUrl": "URL du serveur",
    "username": "Nom d'utilisateur",
    "password": "Mot de passe",
    "adminSection": "Paramètres administrateur",
    "admin": {
      "edit_saved": "Modifier l'enregistrement",
      "send_finalized": "Envoyer finalisé",
      "view_sent": "Voir envoyé",
      "password": "Mot de passe administrateur",
      "advanced": "Administrateur avancé",
      "getBlank": "Obtenir vide",
      "deleteSaved": "Supprimer l'enregistrement",
      "qrCodeScanner": "Scanner de code QR",
      "changeServer": "Changer de serveur",
      "changeAppTheme": "Changer le thème de l'app",
      "changeAppLanguage": "Changer la langue de l'app",
      "changeFontSize": "Changer la taille de police",
      "changeNavigation": "Changer la navigation",
      "maps": "Cartes",
      "periodicUpdates": "Mises à jour périodiques",
      "automaticUpdate": "Mise à jour automatique",
      "hideOldVersions": "Masquer les anciennes versions",
      "changeAutosend": "Changer l'envoi automatique",
      "deleteAfterSend": "Supprimer après envoi",
      "defaultToFinalized": "Finalisé par défaut",
      "changeConstraintBehavior": "Changer le comportement des contraintes",
      "highResolution": "Haute résolution",
      "imageSize": "Taille d'image",
      "guidanceHint": "Indication d'aide",
      "externalAppRecording": "Enregistrement par app externe",
      "instanceFormSync": "Synchronisation des instances du formulaire",
      "changeFormMetadata": "Modifier les métadonnées du formulaire",
      "analytics": "Analytique",
      "movingBackwards": "Retour arrière",
      "accessSettings": "Accéder aux paramètres",
      "changeLanguage": "Changer la langue",
      "jumpTo": "Aller à",
      "saveMid": "Enregistrer intermédiaire",
      "saveAs": "Enregistrer sous",
      "markAsFinalized": "Marquer comme finalisé"
    },
    "actions": {
      "generate": "Générer QR",
      "downloadPng": "Télécharger PNG",
      "copyBase64": "Copier Base64",
      "reset": "Réinitialiser",
      "importJson": "Importer JSON"
    },
    "placeholder": "Générez un code QR pour le voir ici",
    "note": "Le code contient du Base64 zlib d’un JSON general/admin/project. L’auth App User est dans server_url.",
    "general": {
      "theme": "Thème",
      "language": "Langue",
      "fontSize": "Taille de police",
      "navigation": "Navigation",
      "constraintBehavior": "Comportement des contraintes",
      "advanced": "Général avancé",
      "formlistUrl": "URL de la liste des formulaires",
      "submissionUrl": "URL d'envoi",
      "periodicUpdates": "Mises à jour périodiques",
      "deleteAfterSend": "Supprimer après envoi",
      "defaultCompleted": "Complété par défaut",
      "externalAppRecording": "Enregistrement par app externe"
    },
    "formManagement": {
      "title": "Gestion des formulaires",
      "updateMode": "Mode de mise à jour",
      "autosend": "Envoi automatique",
      "imageSize": "Taille d'image",
      "automaticUpdate": "Mise à jour automatique",
      "hideOldVersions": "Masquer les anciennes versions",
      "instanceSync": "Synchronisation des instances",
      "guidanceHint": "Indication d'aide",
      "highResolution": "Haute résolution"
    },
    "maps": {
      "title": "Cartes",
      "basemap": "Carte de base",
      "googleStyle": "Style Google",
      "mapboxStyle": "Style Mapbox",
      "usgsStyle": "Style USGS",
      "cartoStyle": "Style CARTO",
      "referenceLayer": "Couche de référence (chemin)"
    },
    "identity": {
      "title": "Identité",
      "analytics": "Analytique",
      "userName": "Nom d'utilisateur",
      "email": "Courriel",
      "phone": "Téléphone"
    },
    "presets": {
      "title": "Modèles QR",
      "save": "Enregistrer le modèle",
      "load": "Charger un modèle...",
      "delete": "Supprimer",
      "defaultName": "Modèle {number}"
    },
    "preview": {
      "title": "Aperçu JSON",
      "reset": "Réinitialiser",
      "import": "Importer"
    },
    "history": {
      "title": "Codes QR générés",
      "viewAll": "Tout afficher",
      "view": "Voir",
      "download": "Télécharger",
      "copy": "Copier",
      "delete": "Supprimer",
      "more": "... et {count} de plus"
    },
    "placeholders": {
      "qrName": "QR de mon appareil",
      "color": "#C17A3A",
      "url": "https://central.example.org",
      "submissionUrl": "https://.../v1/projects/:id/submissions",
      "referenceLayer": "/storage/maps/layer.mbtiles",
      "icon": "📋",
      "projectName": "Équipe terrain"
    },
    "options": {
      "default": "Par défaut",
      "system": "Système"
    },
    "messages": {
      "nameRequiredForPreset": "Veuillez saisir un nom pour le modèle",
      "nameRequiredForAppUser": "Le nom du code QR est requis pour créer l'utilisateur de l'app",
      "invalidSettings": "Paramètres non valides",
      "generateError": "Échec de la génération du QR et de la création de l'utilisateur de l'app",
      "invalidJsonStructure": "Structure JSON non valide. Doit contenir les sections project, general et admin.",
      "invalidJsonFormat": "Format JSON non valide",
      "copyBase64Error": "Échec de la copie Base64",
      "projectNameRequired": "Le nom du projet est requis",
      "serverRequired": "L’URL du serveur est requise",
      "missingOdkProject": "Ce projet n’a pas d’id projet ODK Central. Réimportez ou vérifiez les paramètres.",
      "generateSuccess": "QR généré et App User créé",
      "presetSaved": "Modèle enregistré",
      "base64Copied": "Base64 copié",
      "jsonImported": "Paramètres importés depuis JSON"
    },
    "workbench": {
      "contextHint": "Créez un QR ODK Collect avec le jeton App User dans l’URL du serveur.",
      "serverReady": "Serveur défini",
      "essentialsTitle": "Configurer",
      "essentialsDesc": "Nommez le QR et la carte Collect, choisissez icône et couleur, puis générez.",
      "nameHint": "Utilisé aussi comme nom affiché de l’App User dans ODK Central.",
      "serverHint": "Issu du serveur ODK lié au projet. La génération injecte /v1/key/{token}/projects/{id}.",
      "advancedTitle": "Options Collect avancées",
      "advancedHint": "Thème, sync formulaires, cartes — optionnel",
      "previewTitle": "Aperçu",
      "previewDesc": "Scannez avec ODK Collect après génération.",
      "libraryHint": "Stocké dans ce navigateur pour ce projet.",
      "libraryEmpty": "Pas encore de QR. Générez-en un pour commencer.",
      "libraryCount": "{count} dans la bibliothèque",
      "serverMeta": "Central: {url}",
      "serverMissing": "Central: non lié — vérifiez le serveur ODK du projet",
      "projectNameHint": "Libellé dans ODK Collect pour cette configuration (pas le nom du projet udacapi).",
      "iconHint": "Affiché sur la carte projet Collect. La valeur par défaut convient le plus souvent.",
      "changeIcon": "Changer l’icône",
      "iconDialogTitle": "Icône du projet Collect",
      "iconDialogSubtitle": "Choisissez un glyphe pour la carte projet sur l’appareil.",
      "applyIcon": "Utiliser l’icône"
    },
    "formAccess": {
      "title": "Formulaires accessibles à ce collecteur",
      "hint": "Sélectionnez au moins un formulaire publié. Sinon, Collect affiche une liste vide.",
      "selectAll": "Tout sélectionner",
      "clear": "Effacer",
      "required": "Sélectionnez au moins un formulaire",
      "assignFailed": "Impossible d’assigner les formulaires à l’App User",
      "manageAll": "Gérer tout l’accès aux formulaires",
      "formsCount": "{n} formulaires",
      "noPublishedForms": "Aucun formulaire publié dans ce projet pour le moment."
    }
  },
  "forms": {
    "state": {
      "open": "Ouvert",
      "closing": "Fermeture",
      "closed": "Fermé",
      "draft": "Brouillon"
    },
    "deleteConfirm": {
      "title": "Supprimer le formulaire",
      "subtitle": "Examinez les conséquences avant de supprimer définitivement ce formulaire.",
      "message": "Cette action est irréversible.",
      "xmlFormId": "XML ID : {id}",
      "confirm": "Supprimer définitivement",
      "importedWarning": "Ce formulaire a été importé depuis ODK Central. Il sera supprimé uniquement de la base de données de cette application et restera sur le serveur ODK Central.",
      "regularWarning": "Cette action déplace le formulaire dans la corbeille ODK Central et le marque comme supprimé localement.",
      "consequenceDataLoss": "Toutes les soumissions et l'historique d'export de ce formulaire seront supprimés de cette application.",
      "irreversible": "Cette action ne peut pas être annulée via l'interface.",
      "success": "Formulaire {name} supprimé.",
      "successImported": "Formulaire {name} supprimé uniquement de la base de données de cette application.",
      "error": "Erreur lors de la suppression du formulaire: {error}"
    },
    "uploadXlsform": {
      "title": "Téléversement XLSForm",
      "subtitle": "Sélectionnez un classeur (.xlsx ou .xls, jusqu'à 50 Mo) pour créer ou mettre à jour un formulaire.",
      "selectFile": "Sélectionner un fichier XLSForm",
      "dropFileTitle": "Déposez votre classeur XLSForm ici",
      "supportedFormats": "Formats acceptés : .xlsx et .xls, jusqu'à 50 Mo.",
      "replaceFileHint": "Choisissez un autre fichier pour remplacer la sélection actuelle.",
      "chooseFile": "Parcourir les fichiers",
      "selectedFile": "Fichier sélectionné:",
      "formSettings": "Identifiant du formulaire",
      "uploadOptions": "Options de téléversement",
      "formId": "ID du formulaire",
      "formIdPlaceholder": "my_form_id",
      "formIdHint": "ID du formulaire unique (seulement lettres, chiffres et underscores)",
      "formIdWarning": {
        "title": "Important !",
        "message": "L'ID du formulaire sera automatiquement extrait du fichier XLSForm ('settings' feuille). Ce champ est utilisé uniquement comme option de secours."
      },
      "updateExisting": "Mettre à jour le formulaire existant",
      "updateExistingHint": "Si un formulaire avec cet ID existe, il sera mis à jour",
      "ignoreWarnings": "Ignorer les avertissements",
      "ignoreWarningsHint": "Ignorer les avertissements lors de la conversion",
      "publishImmediately": "Publier le formulaire immédiatement",
      "publishImmediatelyHint": "Publier le formulaire immédiatement",
      "uploadButton": "Téléverser XLSForm",
      "uploading": "Téléversement...",
      "noFileSelected": "Veuillez sélectionner un fichier pour téléverser",
      "noFormId": "Veuillez entrer l'ID du formulaire",
      "uploadingMessage": "Téléversement XLSForm \"{formId}\"...",
      "successMessage": "XLSForm \"{formId}\" téléversé avec succès !",
      "errorMessage": "Erreur lors du téléversement : {error}",
      "errorFallback": "Échec du téléversement. Veuillez réessayer.",
      "listUpdated": "XLSForm téléversé avec succès ! Liste mise à jour."
    },
    "formDetail": {
      "loading": "Chargement du formulaire...",
      "formLabel": "Formulaire",
      "returnToProjects": "Retour à la liste des projets",
      "sectionShell": {
        "unknownForm": "Formulaire inconnu",
        "loading": "Chargement...",
        "retry": "Réessayer",
        "comingSoonTitle": "Bientôt",
        "comingSoonDescription": "Cette fonctionnalité est en développement. Utilisez d'autres outils de formulaire en attendant."
      },
      "sections": {
        "dashboard": {
          "title": "Aperçu du Formulaire",
          "description": "Statistiques et informations sur le formulaire et les données collectées"
        },
        "autoReports": {
          "title": "Rapports auto",
          "description": "Rapports IA planifiés et à la demande qui couvrent ce formulaire",
          "contextHint": "Planning, livraison et exécution à la demande pour les modèles qui couvrent ce formulaire",
          "manageTemplates": "Gérer les modèles",
          "analysisWindow": "Fenêtre d'analyse",
          "empty": "Aucun rapport auto ne couvre ce formulaire",
          "emptyHint": "Les propriétaires peuvent créer des modèles par défaut ou assigner des formulaires",
          "seed": "Créer les modèles par défaut",
          "loadError": "Impossible de charger les rapports auto",
          "scope": {
            "all": "Tous les formulaires",
            "this": "Ce formulaire",
            "many": "{count} formulaires"
          },
          "delivery": {
            "email": "Email · {count} destinataires",
            "inApp": "Uniquement dans l'app"
          },
          "manualOnly": "Manuel uniquement",
          "lastRun": "Dernière exécution",
          "noLastRun": "Pas encore d'exécution",
          "generate": "Générer",
          "generateNow": "Générer",
          "viewLatest": "Voir le dernier",
          "generating": "Génération du rapport…",
          "started": "Rapport démarré",
          "ribbonManual": "Sans planning · {timezone}",
          "sendToRecipients": "Envoyer à {n} destinataires",
          "sent": "Envoyé",
          "sentToast": "Envoyé à {n} destinataires",
          "sendFailed": "Impossible d'envoyer le rapport",
          "noRecipientsHint": "Ajoutez des destinataires dans Gérer les modèles pour envoyer ce rapport par email"
        },
        "qc": {
          "title": "Contrôle Qualité",
          "description": "Surveiller et valider la qualité des données en utilisant les règles QC",
          "workbench": {
            "createRuleHint": "Définir une nouvelle règle de validation pour ce formulaire",
            "editRuleHint": "Mettre à jour les paramètres et l'expression de la règle",
            "backToRules": "Retour aux règles",
            "pipeline": {
              "ariaLabel": "Workflow de validation QC",
              "define": "Définir des règles",
              "defineHint": "{count} règles configurées",
              "defineEmpty": "Aucune règle — créez votre premier contrôle",
              "validate": "Valider les données",
              "validateHint": "{count} soumissions vérifiées",
              "validateEmpty": "Exécutez la validation sur les soumissions entrantes",
              "review": "Passer en revue les problèmes",
              "reviewHint": "{count} problèmes ouverts",
              "reviewClear": "Aucun problème non résolu"
            }
          }
        },
        "dataExport": {
          "title": "Export de Données",
          "description": "Exporter les données du formulaire dans différents formats"
        },
        "odkExport": {
          "title": "Exportation de données",
          "description": "Exporter les données du formulaire dans différents formats pour analyse",
          "unknownForm": "Formulaire inconnu",
          "exportsCount": "{count} exportations",
          "loadingOptions": "Chargement des options d'exportation...",
          "retry": "Réessayer",
          "infoSubtitleDetailed": "Sélectionnez les formats d'exportation et configurez les options pour télécharger les données de votre formulaire.",
          "formatsAvailable": "{count} formats disponibles",
          "formatsTitle": "Formats d'exportation",
          "selectFormats": "Sélectionnez un ou plusieurs formats à exporter",
          "statisticalFormatsTitle": "Formats statistiques",
          "geoFormatsTitle": "Formats géographiques",
          "noGeoData": "Aucune donnée géographique trouvée dans ce formulaire",
          "configTitle": "Configuration de l'exportation",
          "configSubtitle": "Configurer les options d'exportation et les filtres",
          "dataOptions": "Options de données",
          "includeRepeats": "Inclure les groupes de répétition",
          "includeLabels": "Inclure les étiquettes de champ",
          "includeMetadata": "Inclure les métadonnées",
          "labelLanguage": "Langue de l'étiquette",
          "selectLanguage": "Choisir la langue",
          "loadingLanguages": "Chargement des langues...",
          "generatingLabels": "Génération des étiquettes...",
          "noLabelsAvailable": "Aucune étiquette disponible. Cliquez sur actualiser pour générer les étiquettes.",
          "filters": "Filtres",
          "dateRange": "Plage de dates",
          "startDate": "Date de début",
          "endDate": "Date de fin",
          "dataFilter": "Filtre de données",
          "dataFilterPlaceholder": "ex. âge > 18",
          "readyToExport": "Prêt à exporter",
          "readyToExportSubtitle": "Cliquez sur le bouton pour démarrer le processus d'exportation",
          "labelsRequiredNotice": "Les étiquettes sont requises mais non disponibles. Veuillez d'abord générer les étiquettes.",
          "activeExports": "Exportations actives",
          "exportButton": "Exporter les données",
          "historyTitle": "Historique des exportations",
          "historySubtitle": "Voir et télécharger les exportations précédentes",
          "refresh": "Actualiser",
          "loadingHistory": "Chargement de l'historique...",
          "noHistory": "Pas encore d'exportation",
          "noHistoryDesc": "Commencez par exporter les données dans votre format préféré.",
          "workbench": {
            "contextHint": "Choisissez les formats et les options, puis exécutez l'exportation.",
            "geoAvailable": "Données géographiques",
            "geoUnavailable": "Aucune donnée géographique",
            "optionsTitle": "Options",
            "refreshLabels": "Actualiser les étiquettes",
            "labelsGenerated": "Étiquettes générées ({count} langues)",
            "exportButtonOne": "Exporter 1 format",
            "exportButtonMany": "Exporter {count} formats",
            "selectFormatHint": "Choisissez au moins un format pour exporter.",
            "readySummaryOne": "1 format prêt à exporter.",
            "readySummaryMany": "{count} formats prêts à exporter.",
            "jobsTitle": "Tâches",
            "jobsSubtitle": "Suivre les exportations actives et télécharger les fichiers précédents.",
            "noActiveJobs": "Aucune exportation active.",
            "noHistoryAction": "Choisissez un format ci-dessus et exécutez l'exportation.",
            "pipeline": {
              "sync": "Synchroniser les données",
              "convert": "Convertir",
              "ready": "Prêt"
            }
          },
          "date": "Date",
          "format": "Format",
          "records": "Enregistrements",
          "size": "Taille",
          "user": "Utilisateur",
          "actions": "Actions",
          "download": "Télécharger",
          "viewError": "Voir l'erreur",
          "errorDetails": "Détails de l'erreur",
          "errorSubtitle": "Informations sur l'erreur d'exécution de l'exportation",
          "close": "Fermer",
          "deleteTitle": "Supprimer l'exportation",
          "deleteSubtitle": "Cette action est irréversible",
          "deleteConfirm": "Êtes-vous sûr de vouloir supprimer l'exportation du {date} ? Cette action est irréversible.",
          "cancel": "Annuler",
          "delete": "Supprimer",
          "formatDescriptions": {
            "stata": "Stata",
            "spss": "SPSS",
            "excel": "Excel",
            "csv": "CSV",
            "geojson": "GeoJSON",
            "shapefile": "ESRI Shapefile",
            "kml": "KML",
            "odata": "OData"
          },
          "dateFilters": {
            "all": "Toutes les données",
            "last30": "30 derniers jours",
            "last90": "90 derniers jours",
            "thisyear": "Cette année",
            "lastyear": "L'année dernière",
            "custom": "Plage personnalisée"
          },
          "status": {
            "odataSyncError": "Erreur de vérification de synchronisation OData : {error}",
            "localDataMissing": "Données locales manquantes, téléchargement OData...",
            "odataStatusError": "Erreur d'état OData",
            "downloadingOdata": "Téléchargement OData...",
            "downloadSuccessCount": "{count} soumissions téléchargées",
            "downloadError": "Erreur de téléchargement OData : {error}",
            "geoRequired": "{format} nécessite des données géographiques"
          },
          "notifications": {
            "selectFormat": "Veuillez sélectionner au moins un format",
            "startingDownload": "Démarrage du téléchargement...",
            "downloadSuccess": "Fichier téléchargé avec succès",
            "downloadError": "Erreur de téléchargement : {error}",
            "taskIdMissing": "Impossible de télécharger : l'ID de la tâche est manquant",
            "exportDeleted": "Exportation supprimée avec succès",
            "exportCompleted": "Exportation {format} terminée",
            "exportFailed": "Exportation {format} échouée",
            "trackingError": "Erreur de suivi : {error}",
            "noErrorDetails": "Aucun détail d'erreur disponible",
            "currentUser": "Utilisateur actuel"
          }
        },
        "dataAnalysis": {
          "title": "Analyse des Données",
          "description": "Construire des tables pivot pour une analyse ad-hoc et enregistrer les vues dans le suivi",
          "recordsLoaded": "{count} enregistrements chargés",
          "variablesSelected": "{count} variables sélectionnées",
          "tablesAvailable": "{count} tables disponibles",
          "workbench": {
            "contextHint": "Sélectionnez des variables, explorez avec une table pivot, puis enregistrez une vue dans le suivi",
            "loadingData": "Chargement des données...",
            "pipeline": {
              "ariaLabel": "Workflow d'analyse",
              "source": "Source de données",
              "sourceHint": "{table}",
              "sourceEmpty": "Choisir une table de données",
              "variables": "Variables",
              "variablesHint": "{count} sélectionnées",
              "variablesEmpty": "Choisir des champs à analyser",
              "pivot": "Table pivot",
              "pivotHint": "{count} enregistrements chargés",
              "pivotEmpty": "Charger les données pour explorer",
              "pivotLoading": "Chargement des enregistrements...",
              "save": "Enregistrer la vue",
              "saveHint": "Prêt à enregistrer dans le suivi",
              "saveEmpty": "Configurer la table pivot en premier"
            },
            "source": {
              "title": "Source de données",
              "subtitle": "Choisir quelle table de soumission et comment les valeurs sont affichées",
              "labelsMissing": "Les étiquettes ne sont pas générées pour ce formulaire",
              "labelsMissingHint": "Générer les étiquettes à partir du XLSForm pour afficher les noms de variables et les étiquettes de valeur.",
              "generateLabels": "Générer les étiquettes",
              "table": "Table de données",
              "tablePlaceholder": "Choisir une table de données",
              "displayOptions": "Options d'affichage",
              "showLabels": "Afficher les étiquettes",
              "language": "Langue",
              "includeMetadata": "Inclure les métadonnées"
            },
            "variables": {
              "title": "Variables",
              "selectedCount": "{count} sélectionnées",
              "selectTableFirst": "Choisir une table de données pour voir les variables disponibles.",
              "selectAll": "Sélectionner tout",
              "clearAll": "Effacer tout",
              "searchPlaceholder": "Rechercher des variables...",
              "empty": "Aucune variable ne correspond à votre recherche",
              "moreCount": "+{count} plus",
              "loading": "Chargement...",
              "loadCta": "Charger {count} variables"
            },
            "pivot": {
              "title": "Table pivot",
              "subtitle": "Faites glisser les champs vers les lignes, les colonnes ou les valeurs pour construire votre vue",
              "hint": "Faites glisser les variables vers les lignes, les colonnes ou les valeurs pour construire votre vue.",
              "reprocess": "Retraiter les analyses",
              "saveCta": "Enregistrer dans le suivi",
              "analyticsProcessed": "{percent}% traité"
            },
            "empty": {
              "title": "Sélectionner des variables",
              "hint": "Choisissez une ou plusieurs variables de la table sélectionnée pour commencer votre analyse."
            },
            "save": {
              "title": "Enregistrer la table de suivi",
              "subtitle": "Donnez un nom à cette vue pivot pour pouvoir la trouver sur la page de suivi.",
              "tableName": "Nom de la table",
              "tableNamePlaceholder": "Entrer le nom de la table",
              "description": "Description",
              "descriptionPlaceholder": "Que fait cette table ?",
              "summary": "Résumé de l'analyse",
              "variables": "Variables",
              "table": "Tableau",
              "cancel": "Annuler",
              "confirm": "Enregistrer la table"
            },
            "toasts": {
              "labelsGenerated": "Étiquettes générées. Rechargement des variables...",
              "labelsFailed": "Impossible de générer les étiquettes. Vérifiez que le XLSForm est disponible.",
              "saveSuccess": "Table enregistrée. Ouvrez le suivi pour la voir.",
              "saveFailed": "Impossible d'enregistrer la table. Réessayer ou contacter le support.",
              "formIdMissing": "ID du formulaire non trouvé",
              "reprocessSuccess": "Analytiques retraitées : {count} nouveaux enregistrements",
              "reprocessFailed": "Retraitement des analytiques échoué",
              "reprocessError": "Erreur de retraitement des analytiques : {error}"
            }
          }
        },
        "dataMonitoring": {
          "title": "Suivi des Données",
          "description": "Voir les tables de suivi enregistrées avec des mises à jour en temps réel",
          "tablesCount": "{count} tables disponibles",
          "updating": "Mise à jour...",
          "workbench": {
            "contextHint": "Vues pivot enregistrées avec actualisation des données en temps réel pendant que cette page est ouverte",
            "activeViewsCount": "{count} actives",
            "liveStrip": {
              "ariaLabel": "Statut de suivi",
              "saved": "Tables enregistrées",
              "savedHint": "{count} tables prêtes",
              "savedEmpty": "Aucune table enregistrée encore",
              "watch": "Vue active",
              "watchHint": "Voir {title}",
              "watchEmpty": "Choisir une table à voir",
              "watchDisabled": "Créer une table en premier",
              "sync": "Synchronisation en temps réel",
              "syncHint": "Mises à jour toutes les 30 secondes",
              "syncActive": "Actualisation en cours..."
            },
            "displayOptions": {
              "title": "Options d'affichage",
              "subtitle": "Contrôler la façon dont les noms de variables apparaissent dans les tables pivot",
              "showLabels": "Afficher les étiquettes",
              "language": "Langue"
            },
            "summary": {
              "title": "À un coup d'œil",
              "tables": "Tables enregistrées",
              "activeView": "Vue active",
              "records": "Enregistrements dans la vue",
              "refreshInterval": "Actualisation automatique"
            },
            "tables": {
              "title": "Tables de suivi",
              "subtitle": "Vues pivot enregistrées à partir de l'analyse des données",
              "loading": "Chargement des tables de suivi...",
              "emptyTitle": "Aucune table de suivi encore",
              "emptyHint": "Créer une table pivot sur la page d'analyse et l'enregistrer ici.",
              "createCta": "Aller à l'analyse",
              "realtimeHint": "Les données se mettent à jour toutes les 30 secondes pendant que cette page est ouverte. Utilisez Actualiser pour une mise à jour immédiate.",
              "records": "{count} enregistrements",
              "lastUpdated": "Dernière mise à jour {time}",
              "view": "Voir",
              "hide": "Masquer",
              "loadingPivot": "Chargement des données pivot...",
              "public": "Public",
              "private": "Privé"
            },
            "delete": {
              "title": "Supprimer la table",
              "confirm": "Supprimer la table \"{title}\"?",
              "detail": "Cette action supprime définitivement la table et ses données mises en cache.",
              "cancel": "Annuler",
              "confirmBtn": "Supprimer la table"
            }
          }
        },
        "settings": {
          "title": "Paramètres",
          "description": "Gestion des paramètres du formulaire",
          "formStatus": "État du formulaire",
          "basicSettings": "Paramètres de Base",
          "notifications": {
            "noChanges": "Aucun changement à sauvegarder",
            "draftWarning": "Les brouillons de formulaires ne peuvent pas être modifiés via cette interface. Publiez d'abord le formulaire.",
            "stateChangeHint": "La modification du statut du formulaire affecte l'acceptation des nouvelles soumissions.",
            "invalidState": "État de formulaire invalide : {state}",
            "success": "État du formulaire modifié avec succès vers {state}",
            "error": "Erreur lors de la modification de l'état du formulaire : {error}",
            "errorLog": "Erreur lors de la modification de l'état du formulaire"
          },
          "version": {
            "title": "Version",
            "notSpecified": "Non spécifiée",
            "history": "Historique des Versions",
            "noHistory": "Aucun historique de versions disponible",
            "download": "Télécharger",
            "restore": "Restaurer",
            "uploadNew": "Télécharger Nouvelle Version",
            "author": "Auteur"
          },
          "dataCollectors": {
            "title": "Collecteurs de données",
            "description": "Gérer l'accès des utilisateurs à la collecte de données du formulaire",
            "noCollectors": "Aucun collecteur de données assigné",
            "addCollector": "Ajouter un collecteur",
            "editCollector": "Modifier un collecteur",
            "removeCollector": "Supprimer un collecteur",
            "addCollectorModal": {
              "title": "Ajouter un collecteur de données",
              "placeholder": "Stub : ici sera le formulaire pour ajouter un collecteur de données"
            }
          },
          "publicAccess": {
            "title": "Accès public",
            "description": "Créer un lien public pour la collecte de données via l'interface web",
            "publicLink": "Lien Public",
            "disable": "Désactiver",
            "requireAuth": "Exiger l'authentification",
            "collectEmail": "Collecter l'email",
            "limitSubmissions": "Limiter le nombre de réponses",
            "maxSubmissions": "Nombre maximum de réponses",
            "updateSettings": "Mettre à jour les paramètres",
            "createLink": "Créer un lien public",
            "notCreated": "Lien public non créé. Créez un lien pour la collecte de données via l'interface web.",
            "created": "Lien public créé",
            "copied": "Lien copié dans le presse-papiers",
            "disabled": "Lien public désactivé",
            "updated": "Paramètres du lien public mis à jour"
          },
          "qrCodes": {
            "title": "Codes QR pour la collecte de données",
            "description": "Gérer les codes QR pour configurer les appareils de collecte de données pour ce formulaire",
            "assignedTitle": "Codes QR assignés",
            "availableTitle": "Codes QR du projet disponibles",
            "createNew": "Créer un nouveau code QR",
            "noAvailable": "Aucun code QR disponible",
            "createInstruction": "Créez un code QR pour configurer les appareils de collecte de données",
            "manageOnProject": "Les codes QR ODK Collect sont gérés au niveau du projet (App Users).",
            "openProjectQr": "Ouvrir les codes QR du projet",
            "openFormAccess": "Gérer l’accès aux formulaires",
            "notifications": {
              "assigned": "Code QR assigné au formulaire",
              "unassigned": "Code QR désassigné du formulaire",
              "copied": "Base64 copié dans le presse-papiers",
              "copyError": "Erreur de copie : {error}"
            }
          },
          "attachments": {
            "title": "Pièces Jointes et Fichiers Multimédia",
            "description": "Gérer les fichiers et pièces jointes associés au formulaire",
            "xlsformFile": "Fichier XLSForm",
            "xlsformDescription": "Télécharger le fichier XLSForm original de ce formulaire au format Excel",
            "downloadXlsform": "Télécharger XLSForm",
            "manageAttachments": "Gérer les Pièces Jointes",
            "downloadSuccess": "Fichier XLSForm téléchargé avec succès",
            "downloadError": "Erreur lors du téléchargement du fichier XLSForm",
            "fileNotFound": "Fichier XLSForm non trouvé pour ce formulaire",
            "accessDenied": "Aucun accès pour télécharger le fichier XLSForm",
            "serverError": "Erreur du serveur : {status}"
          },
          "analytics": {
            "title": "Gestion des analytiques",
            "recreateAnalytics": "Forcer la recréation des analytiques",
            "description": "Recréer les données analytiques pour toutes les soumissions. À utiliser lorsque les données sont corrompues ou manquantes.",
            "warning": "Cette opération supprimera toutes les analytiques existantes et les recréera à partir des données brutes des soumissions.",
            "confirmTitle": "Confirmer la recréation des analytiques",
            "alertTitle": "Attention : recréation des données requise",
            "alertDescription": "Cette action supprimera définitivement toutes les données analytiques existantes et les recréera de zéro.",
            "whatWillHappen": "Ce qui va se passer :",
            "step1": "Toutes les données analytiques existantes seront supprimées",
            "step2": "Les données brutes des soumissions seront retraitées",
            "step3": "De nouvelles données analytiques seront créées avec le bon formatage",
            "step4": "Les tableaux croisés dynamiques et les analyses fonctionneront correctement",
            "timeWarning": "Cette opération peut prendre plusieurs minutes pour les formulaires avec beaucoup de soumissions.",
            "recreateButton": "Forcer la recréation des analytiques",
            "confirmButton": "Oui, recréer les analytiques",
            "success": "Analytiques recréées avec succès ! {processed} soumissions traitées, {recreated} enregistrements analytiques recréés sur {total} soumissions au total.",
            "error": "Échec de la recréation des données analytiques",
            "apiError": "Erreur API : {error}"
          },
          "dangerZone": {
            "title": "Zone de Danger",
            "deleteForm": "Supprimer le Formulaire",
            "description": "Cette action ne peut pas être annulée. Toutes les données collectées seront perdues.",
            "confirmDelete": "Confirmer la Suppression du Formulaire",
            "confirmMessage": "Êtes-vous sûr de vouloir supprimer le formulaire \"{name}\" ?",
            "confirmDescription": "Cette action ne peut pas être annulée. Toutes les données collectées seront perdues.",
            "enterFormName": "Entrez le nom du formulaire pour confirmer",
            "deleteFormButton": "Supprimer le Formulaire",
            "formDeleted": "Formulaire supprimé (fonction stub)"
          }
        },
        "datasets": {
          "title": "Ensembles de Données",
          "description": "Gestion des ensembles de données et entités"
        }
      },
      "errors": {
        "missingParams": "Paramètres requis manquants pour charger le formulaire",
        "loadError": "Erreur lors du chargement des données du formulaire",
        "unknownError": "Erreur inconnue"
      }
    },
    "dashboard": {
      "loading": "Chargement des analyses...",
      "analyticsError": "Erreur lors du chargement des analyses",
      "retry": "Réessayer le chargement",
      "workbench": {
        "contextHint": "Identité du formulaire, collecte, chronologie et AI pour une période partagée (7 / 30 / all).",
        "completionBadge": "{rate}% de complétion",
        "metaVersion": "v{version}",
        "metaPublished": "pub. {date}",
        "metaUpdated": "maj. {date}",
        "summaryTitle": "Résumé de collecte",
        "sections": {
          "metadata": {
            "title": "Identité du formulaire",
            "xmlFormId": "ID XML du formulaire",
            "version": "Version",
            "published": "Publié",
            "updated": "Dernière mise à jour"
          },
          "intake": {
            "title": "Résumé de collecte",
            "subtitle": "Soumissions aujourd'hui, cette semaine et au total"
          },
          "quickLinks": {
            "title": "Liens rapides"
          },
          "agent": {
            "title": "Assistant IA",
            "subtitle": "Résumés, rapports analytiques ou chat sur ce formulaire"
          },
          "timeline": {
            "title": "Chronologie des soumissions",
            "subtitle": "Volume quotidien sur la période sélectionnée"
          },
          "map": {
            "title": "Répartition géographique",
            "subtitle": "Emplacements des soumissions avec données geo"
          }
        },
        "metrics": {
          "noChange": "Aucun changement"
        },
        "intakeStrip": {
          "ariaLabel": "État de la collecte de données",
          "today": "Aujourd'hui",
          "todayDelta": "{delta} vs hier",
          "todayFlat": "Comme hier",
          "week": "Cette semaine",
          "weekDelta": "{delta} vs semaine dernière",
          "weekFlat": "Comme la semaine dernière",
          "total": "Toutes les réponses",
          "totalHint": "Total collecté pour ce formulaire",
          "totalEmpty": "Pas encore de réponses"
        }
      },
      "cards": {
        "totalSubmissions": {
          "title": "Total des Soumissions",
          "today": "aujourd'hui"
        },
        "completedSubmissions": {
          "title": "Soumissions Terminées",
          "rate": "taux de finalisation"
        },
        "dataCollectors": {
          "title": "Collecteurs de Données",
          "new": "nouveaux"
        },
        "problematicSubmissions": {
          "title": "Soumissions Problématiques"
        },
        "submissionTimeline": {
          "title": "Chronologie des Soumissions",
          "totalForPeriod": "Total pour la période",
          "noData": "Aucune donnée de chronologie des soumissions",
          "noSubmissionsInPeriod": "Aucune soumission pour la période sélectionnée",
          "stats": {
            "totalSubmissions": "Total des soumissions",
            "maxPerDay": "Maximum par jour",
            "trend": "Tendance"
          },
          "timeframes": {
            "7days": "7 derniers jours",
            "30days": "30 derniers jours",
            "90days": "90 derniers jours",
            "allFormData": "Toutes les données du formulaire"
          },
          "trend": {
            "stable": "Aucun changement",
            "growth": "Croissance",
            "decline": "Diminution"
          },
          "hint": "Cliquez sur une barre pour voir les informations détaillées du jour"
        }
      }
    },
    "summaryCard": {
      "id": "ID",
      "statusNotSet": "Statut non défini",
      "statusDescriptions": {
        "published": "Le formulaire est ouvert pour la collecte de données",
        "closing": "Le formulaire se ferme, les nouvelles réponses sont limitées",
        "closed": "Le formulaire est fermé, les nouvelles réponses ne sont pas acceptées",
        "draft": "Le formulaire est en mode brouillon, non publié",
        "unknown": "Statut non reconnu"
      },
      "stats": {
        "today": "Aujourd'hui",
        "week": "Cette semaine",
        "total": "Total collecté",
        "responses": "réponses au formulaire",
        "fromYesterday": "depuis hier",
        "fromLastWeek": "depuis la semaine dernière"
      },
      "info": {
        "version": "Version",
        "notSpecified": "Non spécifié",
        "created": "Créé",
        "updated": "Mis à jour",
        "notUpdated": "Non mis à jour",
        "published": "Publié",
        "notPublished": "Non publié",
        "notSpecifiedDate": "Non spécifié"
      },
      "trend": {
        "title": "Tendance de remplissage pour les 7 derniers jours",
        "noData": "Aucune donnée",
        "growth": "Croissance",
        "decline": "Diminution",
        "stable": "Aucun changement"
      }
    },
    "attachments": {
      "title": "Pièces jointes du formulaire",
      "formLabel": "Formulaire:",
      "noAttachmentsRequired": "Aucune pièce jointe requise",
      "noAttachmentsDescription": "Ce formulaire ne contient pas de références à des fichiers externes (images, documents, etc.).",
      "noAttachmentsHint": "Si vous ajoutez des références de fichiers dans XLSForm, elles apparaîtront automatiquement ici.",
      "uploadSection": {
        "supportedFormats": "Formats supportés:",
        "dropZoneTitles": {
          "uploadMissing": "Télécharger les fichiers manquants",
          "updateExisting": "Mettre à jour les fichiers existants",
          "uploadFiles": "Télécharger des fichiers"
        },
        "dropZoneDescriptions": {
          "uploadMissing": "Attendu {count} fichier(s): {files}",
          "updateExisting": "Tous les fichiers sont téléchargés. Vous pouvez les remplacer par de nouvelles versions.",
          "uploadFiles": "Sélectionnez des fichiers pour télécharger les pièces jointes du formulaire."
        },
        "dropZoneButtons": {
          "selectFiles": "Sélectionner des fichiers",
          "updateFiles": "Mettre à jour les fichiers",
          "chooseFiles": "Choisir des fichiers"
        },
        "selectedFiles": "Fichiers sélectionnés ({count})",
        "uploadButton": "Télécharger {count} fichiers",
        "uploading": "Téléchargement...",
        "clear": "Effacer",
        "chooseFiles": "Choisir des fichiers"
      },
      "table": {
        "columns": {
          "name": "Nom du fichier",
          "status": "Statut",
          "type": "Type",
          "size": "Taille",
          "updatedAt": "Date de téléchargement",
          "actions": "Actions"
        },
        "status": {
          "uploaded": "Téléchargé",
          "missing": "Manquant",
          "deleted": "Supprimé",
          "unknown": "Inconnu"
        },
        "actions": {
          "download": "Télécharger",
          "delete": "Supprimer",
          "deleted": "Supprimé",
          "missing": "Manquant"
        },
        "notSpecified": "Non spécifié"
      },
      "messages": {
        "uploadSuccess": "Téléchargé avec succès {count} fichiers",
        "uploadError": "Erreur lors du téléchargement des fichiers: {error}",
        "fileNotFound": "Fichier {filename} non trouvé dans les fichiers sélectionnés",
        "fileUploadSuccess": "Fichier {filename} téléchargé avec succès",
        "fileUploadError": "Erreur lors du téléchargement du fichier {filename}: {error}",
        "downloadError": "Erreur lors du téléchargement du fichier {filename}: {error}",
        "deleteSuccess": "Fichier {filename} supprimé avec succès",
        "deleteError": "Erreur lors de la suppression du fichier {filename}: {error}",
        "invalidFilesIgnored": "Les fichiers suivants seront ignorés (non trouvés dans la liste attendue): {files}",
        "filesWillBeUpdated": "Les fichiers suivants seront mis à jour: {files}",
        "loadingError": "Erreur lors du chargement des pièces jointes",
        "downloadSuccess": "Fichier {filename} téléchargé avec succès",
        "fileAlreadyDeleted": "Le fichier {filename} a déjà été supprimé ou n'existe pas",
        "fileNotInExpectedList": "Fichier non trouvé dans la liste des pièces jointes attendues"
      },
      "confirmDelete": {
        "title": "Confirmer la suppression",
        "message": "Êtes-vous sûr de vouloir supprimer le fichier \"{filename}\"?",
        "warning": "Cette action ne peut pas être annulée.",
        "deleting": "Suppression...",
        "delete": "Supprimer"
      }
    }
  },
  "pageNotFound": {
    "title": "Oups ! Page introuvable.",
    "subtitle": "404",
    "description": "La page que vous cherchez n'existe pas ou a été déplacée.",
    "goBack": "Retour",
    "goHome": "Aller à l'accueil",
    "copyright": "© {year} UDACAPI. Tous droits réservés."
  },
  "maps": {
    "tabTitle": "Carte",
    "pageTitle": "Carte du projet",
    "subtitle": "Suivez en temps réel les soumissions géolocalisées",
    "empty": {
      "noGeoForms": "Aucun formulaire de ce projet ne contient de question GPS.",
      "noPoints": "Aucune soumission ne correspond aux filtres actuels."
    },
    "filters": {
      "title": "Filtres",
      "forms": "Formulaires",
      "dateFrom": "Du",
      "dateTo": "Au",
      "qcStatus": "Statut QC",
      "enumerator": "Enquêteur",
      "heatmap": "Carte de chaleur",
      "reset": "Réinitialiser",
      "apply": "Appliquer"
    },
    "qcStatuses": {
      "any": "Tous",
      "pass": "Validé",
      "fail": "Échec",
      "warning": "Avertissement",
      "error": "Erreur",
      "none": "Non validé"
    },
    "actions": {
      "export": "Exporter en GeoJSON",
      "refresh": "Actualiser",
      "settings": "Paramètres de la carte",
      "openSubmission": "Ouvrir la soumission",
      "openFormOnMap": "Voir le formulaire sur la carte"
    },
    "popup": {
      "submittedAt": "Soumis le",
      "submittedBy": "Soumis par",
      "form": "Formulaire",
      "status": "Statut QC"
    },
    "truncated": "Affichage des {limit} premiers points. Affinez les filtres ou activez le clustering pour en voir plus.",
    "settingsDialog": {
      "title": "Paramètres de la carte du projet",
      "defaultCenter": "Centre par défaut",
      "defaultCenterHint": "Cliquez sur la carte pour choisir un emplacement",
      "defaultZoom": "Zoom par défaut",
      "defaultForms": "Formulaires par défaut",
      "heatmapDefault": "Afficher la carte de chaleur par défaut",
      "coordinateFields": "Champs de coordonnées",
      "latitudeField": "Champ de latitude",
      "longitudeField": "Champ de longitude",
      "automaticDetection": "Utiliser la détection automatique",
      "coordinateSourceTitle": "Source des coordonnées",
      "coordinateMode": "Mode de coordonnées",
      "modeAuto": "Détection automatique",
      "modeNone": "Pas de données de localisation",
      "modeLatLon": "Champs latitude et longitude",
      "modeGeopoint": "Champ geopoint",
      "geopointField": "Champ geopoint",
      "detectedSource": "Source détectée : {path} · points actuels : {count}",
      "configureCoordinates": "Champs de coordonnées",
      "noMapHint": "Aucun point sur la carte pour ce formulaire. Configurez les champs de coordonnées si les soumissions contiennent des localisations.",
      "save": "Enregistrer",
      "cancel": "Annuler",
      "saved": "Paramètres enregistrés"
    },
    "savedViews": {
      "title": "Vues enregistrées",
      "noViewsYet": "Aucune vue enregistrée — en créer sur la carte du projet",
      "recommended": "Recommandée",
      "defaultLabel": "par défaut",
      "saveHint": "Après Appliquer, la carte utilise vos filtres et la carte de chaleur. « Enregistrer la vue actuelle » enregistre cette configuration sous un nom (gestionnaires du projet uniquement).",
      "saveCurrent": "Enregistrer la vue actuelle",
      "updateCurrent": "Mettre à jour la vue",
      "delete": "Supprimer la vue",
      "name": "Nom de la vue",
      "pinAsDefault": "Définir par défaut",
      "pin": "Épingler la vue",
      "saved": "Vue enregistrée",
      "updated": "Vue mise à jour",
      "deleted": "Vue supprimée",
      "saveFailed": "La vue n'a pas pu être enregistrée. Vérifiez que l'API est déployée et que les migrations de la base de données incluent project_map_views.",
      "updateFailed": "La vue n'a pas pu être mise à jour.",
      "deleteFailed": "La vue n'a pas pu être supprimée."
    },
    "tileConfig": {
      "sectionTitle": "Serveur de tuiles",
      "sectionDescription": "Indiquez un modèle d'URL de serveur de tuiles pour votre organisation. Laissez vide pour utiliser les tuiles publiques d'OpenStreetMap.",
      "url": "Modèle d'URL des tuiles",
      "urlPlaceholder": "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      "attribution": "Attribution",
      "subdomains": "Sous-domaines",
      "maxZoom": "Zoom max.",
      "minZoom": "Zoom min.",
      "test": "Tester l'URL",
      "configure": "Configurer",
      "edit": "Modifier",
      "defaultTiles": "Utilisation des tuiles publiques OpenStreetMap",
      "zoom": "Zoom",
      "clear": "Effacer",
      "save": "Enregistrer",
      "saved": "Configuration des tuiles enregistrée",
      "cleared": "Serveur de tuiles personnalisé effacé"
    }
  },
  "help": {
    "title": "Aide",
    "subtitle": "Guides courts et réponses pour les tâches courantes dans UDACAPI.",
    "searchPlaceholder": "Rechercher des guides et des questions…",
    "learnMore": "En savoir plus",
    "openGuide": "Ouvrir",
    "openGuideFormScope": "Ouvrir le tableau de bord — puis choisir un projet et un formulaire",
    "whenToUse": "Quand l'utiliser",
    "steps": "Étapes",
    "comingSoon": "D'autres guides sur l'analyse, la surveillance et les paramètres de l'organisation arrivent bientôt.",
    "noResults": "Aucun guide ne correspond à votre recherche.",
    "featureGuides": {
      "odkServers": {
        "title": "Serveurs ODK",
        "summary": "Connectez votre serveur ODK Central (ou compatible) pour que UDACAPI puisse synchroniser projets et soumissions.",
        "whenToUse": "Configuration initiale, avant synchronisation ou import.",
        "steps": [
          "Ouvrez Serveurs ODK dans la barre latérale.",
          "Ajoutez l'URL du serveur et les identifiants.",
          "Lancez Tester la connexion.",
          "Corrigez l'URL, les identifiants ou les problèmes réseau avant de synchroniser."
        ]
      },
      "sync": {
        "title": "Sync Workbench",
        "summary": "Récupérez les nouvelles soumissions et actualisez la structure du formulaire depuis ODK.",
        "whenToUse": "Après connexion du serveur ; lorsque vous attendez de nouvelles données terrain.",
        "steps": [
          "Ouvrez Sync Workbench.",
          "Sélectionnez serveur, projet et formulaire.",
          "Vérifiez le curseur et le statut de la dernière synchronisation.",
          "Démarrez la synchronisation et attendez la fin.",
          "Ouvrez le formulaire — Overview, Export ou QC."
        ]
      },
      "import": {
        "title": "Importer projets et formulaires",
        "summary": "Importez des projets et formulaires ODK existants dans votre organisation.",
        "whenToUse": "Migration depuis ODK ou intégration d'un nouveau serveur.",
        "steps": [
          "Assurez-vous que le serveur ODK est connecté et testé.",
          "Depuis Projets, lancez Importer (serveurs appartenant à l'organisation uniquement).",
          "Sélectionnez un projet et importez les formulaires.",
          "Ouvrez un formulaire et vérifiez Overview et Settings."
        ]
      },
      "xlsformAssist": {
        "title": "XLSForm Assist",
        "summary": "Workbench AI pour rédiger, prévisualiser et publier des modifications XLSForm.",
        "whenToUse": "Nouvelles enquêtes ou changements majeurs de schéma.",
        "steps": [
          "Ouvrez un projet et lancez XLSForm Assist.",
          "Décrivez l'enquête ou téléversez un fichier de questions.",
          "Vérifiez l'aperçu ODK Web Forms.",
          "Confirmez la publication et attendez la fin du job."
        ]
      },
      "formOverview": {
        "title": "Form Overview",
        "summary": "Instantané de la collecte, chronologie, carte et Q&R AI pour la période sélectionnée.",
        "whenToUse": "Suivi quotidien ; questions rapides sur les données en direct du formulaire.",
        "steps": [
          "Ouvrez un formulaire et allez à Overview.",
          "Choisissez la période (7 / 30 / all) — partagée par les rapports AI et la chronologie.",
          "Consultez la chronologie et la carte.",
          "Utilisez le chat AI ou générez des rapports récapitulatifs pour la même fenêtre."
        ]
      },
      "autoReports": {
        "title": "Rapports automatiques",
        "summary": "Rapports AI planifiés et à la demande par formulaire avec envoi par email.",
        "whenToUse": "Mises à jour régulières pour les parties prenantes (hebdomadaire ou mensuel).",
        "steps": [
          "Org → Modèles de rapport — créez ou choisissez un modèle.",
          "Formulaire → Rapports automatiques — définissez le planning et les destinataires.",
          "Utilisez Generate pour un aperçu manuel avec période.",
          "Utilisez Send pour livrer après l'aperçu."
        ]
      },
      "qc": {
        "title": "Contrôle qualité (QC)",
        "summary": "Règles de validation sur les soumissions ; l'AI peut suggérer un pack de démarrage.",
        "whenToUse": "Après les premières soumissions ; avant de faire confiance aux exports ou analyses.",
        "steps": [
          "Ouvrez un formulaire et allez à QC.",
          "Créez une règle ou utilisez la suggestion AI.",
          "Lancez la validation.",
          "Examinez les soumissions signalées."
        ]
      },
      "export": {
        "title": "Export de données",
        "summary": "Exportez les soumissions en CSV, Excel et plus ; les grands formulaires utilisent des jobs asynchrones.",
        "whenToUse": "Transfert vers Excel, SPSS, Stata ou pipelines externes.",
        "steps": [
          "Ouvrez un formulaire et allez à Data Export.",
          "Choisissez le format et les options.",
          "Démarrez l'export et attendez le job.",
          "Téléchargez le fichier depuis la liste des jobs."
        ]
      }
    },
    "faq": {
      "title": "Questions fréquentes",
      "items": {
        "sync-no-new-data": {
          "question": "Pourquoi la synchronisation ne récupère-t-elle pas de nouvelles soumissions ?",
          "answer": "Vérifiez que le serveur ODK est accessible, que le curseur de sync n'est pas bloqué sur une ancienne position, que vous avez sélectionné le bon formulaire et que votre compte a accès à ce projet. Lancez Tester la connexion sur le serveur, puis relancez la sync depuis Sync Workbench."
        },
        "sync-cursor": {
          "question": "Qu'est-ce qu'un curseur de synchronisation ?",
          "answer": "Un curseur est le pointeur de synchronisation incrémentielle — où UDACAPI s'est arrêté lors de la dernière lecture des soumissions. Réinitialiser ou désaligner les curseurs peut ignorer ou re-télécharger des données ; utilisez Sync Workbench pour inspecter le statut du curseur avant de forcer une resynchronisation complète."
        },
        "import-server-type": {
          "question": "Pourquoi ne puis-je pas importer depuis ce serveur ?",
          "answer": "L'import de projet n'est autorisé que sur les serveurs ODK appartenant à l'organisation. Les serveurs Shared et Global ne peuvent pas être utilisés pour l'import — connectez un serveur org ou contactez votre administrateur."
        },
        "import-how": {
          "question": "Comment importer un projet ODK existant ?",
          "answer": "Connectez et testez le serveur, puis allez à Projets → Importer, choisissez le projet et importez les formulaires. Consultez le guide Importer projets et formulaires ci-dessus pour les instructions pas à pas."
        },
        "xlsform-where": {
          "question": "Où se trouve XLSForm Assist ?",
          "answer": "Ouvrez un projet depuis Projets, puis lancez XLSForm Assist depuis la zone formulaires du projet (ou la route assist dédiée à ce projet)."
        },
        "ai-scope": {
          "question": "Que peut répondre l'AI du formulaire ?",
          "answer": "Des questions sur le schéma du formulaire, les soumissions, l'analytique, les règles QC et le statut de sync — basées sur les données en direct de ce formulaire. Elle ne remplace pas la validation QC ni l'examen juridique des données personnelles."
        },
        "ai-quota": {
          "question": "Pourquoi vois-je quota dépassé ?",
          "answer": "Votre organisation a atteint une limite d'utilisation de l'agent. Attendez la fenêtre de réinitialisation ou contactez le propriétaire ou l'administrateur de l'organisation pour ajuster les limites."
        },
        "auto-generate-vs-schedule": {
          "question": "Quelle est la différence entre Generate et un rapport planifié ?",
          "answer": "Generate s'exécute à la demande pour la période choisie sur le formulaire. Les exécutions planifiées suivent le cron du modèle et utilisent la fenêtre de données alignée sur le planning — pas forcément la même que le sélecteur de période Overview."
        },
        "auto-templates": {
          "question": "Où gérer les modèles de rapport ?",
          "answer": "Au niveau organisation : Mon organisation → Modèles de rapport (ou le lien rapide modèles). Les modèles sont centraux org ; l'onglet Rapports automatiques de chaque formulaire affiche les modèles couvrant ce formulaire."
        },
        "qc-first-rule": {
          "question": "Comment créer ma première règle QC ?",
          "answer": "Ouvrez le formulaire → QC → Créer une règle, ou utilisez la suggestion AI pour rédiger un pack de démarrage à partir de la structure du formulaire, puis lancez la validation."
        },
        "export-slow": {
          "question": "L'export prend longtemps — est-ce normal ?",
          "answer": "Oui pour les grands formulaires. Les exports s'exécutent en jobs en arrière-plan. Gardez la page ouverte ou revenez à Data Export pour télécharger quand le job est terminé."
        },
        "export-where": {
          "question": "Où est mon fichier exporté ?",
          "answer": "Dans l'onglet Data Export du formulaire — dans la liste jobs/historique avec action de téléchargement quand le statut du job est complete."
        },
        "permissions-missing": {
          "question": "Je ne vois pas un projet ou un onglet",
          "answer": "Votre groupe de permissions peut ne pas inclure ce projet ou cette fonctionnalité. Demandez au propriétaire de l'organisation de vérifier les groupes de permissions et l'accès aux projets."
        }
      }
    },
    "support": {
      "title": "Besoin de plus d'aide ?",
      "body": "Contactez le support UDACAPI si ces guides ne résolvent pas votre problème.",
      "contactLabel": "Envoyer un email au support"
    }
  }
}
